webpackJsonp([17,47],{

/***/ 1065:
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1099),
  /* template */
  __webpack_require__(1114),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1099:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    ShareButton: __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue___default.a
  },
  props: ["item", "trigger"],
  mounted: function mounted() {
    this.getFavourited;
    var self = this;
    window.addEventListener('resize', function () {
      var height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

      if (height <= 452) {
        self.resize = {
          overflowY: 'scroll',
          marginBottom: '15px',
          height: '195px'
        };
        return;
      }

      if (height < 670) {
        self.resize = {
          overflowY: 'scroll',
          marginBottom: '15px',
          height: '216px'
        };
        return;
      }

      self.resize = {};
    }, false);
  },
  data: function data() {
    return {
      favorited: false,
      seen: false,
      resize: {}
    };
  },
  methods: {
    copyToClipboard: function copyToClipboard(link) {
      var self = this;
      this.$copyText(link).then(function (e) {
        var snackbar = {
          active: true,
          text: 'Link Successfully Copied To Clipboard'
        };
        self.$store.dispatch('triggerSnackbar', snackbar);
        setTimeout(function () {
          var snackbar = {
            active: false,
            text: ''
          };
          self.$store.dispatch('triggerSnackbar', snackbar);
        }, 2000);
      }, function (e) {
        var snackbar = {
          active: true,
          text: 'Unable To Copy Link To Clipboard'
        };
        self.$store.dispatch('triggerSnackbar', snackbar);
      });
    },
    closeViewEvent: function closeViewEvent() {
      this.$emit("closeModal");
    },
    favoriteItem: function favoriteItem() {
      var favoritePayload = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, this.item.uid, this.item.uid);

      var self = this;
      self.favorited = true;
      this.$firebase.database().ref("favorites/events/".concat(this.userDetails.uid, "/").concat(this.item.eventKey)).set(favoritePayload);
    },
    unfavoriteItem: function unfavoriteItem() {
      var self = this;
      self.favorited = false;
      this.$firebase.database().ref("favorites/events/".concat(this.userDetails.uid, "/").concat(this.item.eventKey)).set(null);
    },
    getFavourited: function getFavourited() {
      var self = this;
      this.$firebase.database().ref("favorites/events/".concat(this.userDetails.uid, "/").concat(this.item.eventKey)).on('value', function (snapshot) {
        if (!snapshot.val()) {
          self.favorited = false;
        } else {
          self.favorited = true;
        }
      });
    }
  },
  computed: {
    userDetails: function userDetails() {
      return this.$store.getters.getUserDetails;
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    },
    dialog: {
      get: function get() {
        if (this.trigger) {
          this.favorited = false;
          this.getFavourited();
        }

        return this.trigger;
      },
      set: function set(val) {
        this.$emit("closeModal");
      }
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    link: function link() {
      var link = "https://".concat(window.location.host, "/events#id=").concat(this.item.eventKey);
      return link;
    }
  }
};

/***/ }),

/***/ 1102:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".event_icon img{width:50px}.event_title span{font-size:20px;color:#fff;line-height:22px}.event_share{float:left;margin:10px 0}.event_share .btn{height:auto}.event_link a{color:#000;text-decoration:none}.event_link a:hover{text-decoration:underline}.share_list{position:absolute;top:0}.share_list a{height:auto;font-size:12px;color:#666}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/grouppage/events/EventViewModal.vue"],"names":[],"mappings":"AACA,gBACE,UAAW,CACZ,AACD,kBACE,eAAgB,AAChB,WAAa,AACb,gBAAkB,CACnB,AACD,aACE,WAAW,AACX,aAAc,CACf,AACD,kBACE,WAAY,CACb,AACD,cACE,WAAW,AACX,oBAAsB,CACvB,AACD,oBACG,yBAA2B,CAC7B,AACD,YACE,kBAAmB,AACnB,KAAO,CACR,AACD,cACE,YAAY,AACZ,eAAgB,AAChB,UAAY,CACb","file":"EventViewModal.vue","sourcesContent":["\n.event_icon img{\n  width:50px;\n}\n.event_title span{\n  font-size: 20px;\n  color: white;\n  line-height: 22px;\n}\n.event_share{\n  float:left;\n  margin:10px 0;\n}\n.event_share .btn{\n  height:auto;\n}\n.event_link a{\n  color:#000;\n  text-decoration: none;\n}\n.event_link a:hover{\n   text-decoration: underline;\n}\n.share_list{\n  position: absolute;\n  top: 0;\n}\n.share_list a{\n  height:auto;\n  font-size: 12px;\n  color: #666;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1102);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("59092817", content, true, {});

/***/ }),

/***/ 1114:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "max-width": "600px",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    style: ({
      backgroundColor: this.styles.general.theme_color_light
    })
  }, [_c('v-layout', [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.closeViewEvent
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "pb-4 mx-2 px-2"
  }, [_c('v-flex', {
    staticClass: "text-xs-center event_icon",
    attrs: {
      "xs2": ""
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.item.logo ? _vm.item.logo : '/static/images/event-icon.png'
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "mx-4 event_title",
    attrs: {
      "xs10": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title))])])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', {
    staticClass: "event_share",
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "medium": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("date_range")]), _vm._v("\n            RSVP\n          ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "event_share",
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [(!_vm.favorited) ? _c('v-btn', {
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "medium": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n            Favorite\n          ")], 1)], 1) : _c('v-btn', {
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "medium": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n            Favorite\n          ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "event_share",
    attrs: {
      "xs4": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "text": "Share",
      "size": "28px",
      "link": _vm.link
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mx-3",
    style: (_vm.resize),
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Description")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.item.description || '-'))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("query_builder")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("actualDate")(_vm.item.eventdate)) + " at " + _vm._s(_vm.item.starteventtime) + " ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("room")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.location || '-'))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("date_range")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.user.firstname + ' ' + _vm.item.user.lastname) + " - " + _vm._s(_vm.item.user.jobtitle || '-'))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "my-2 event_link",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-icon', [_vm._v("link")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.item.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.link))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * vue-fullcalendar v1.0.9
 * (c) 2017 Sunny Wang <sunnywang0104@163.com> 
 * @license MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["VueFullcalendar"] = factory();
	else
		root["VueFullcalendar"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	var _fullCalendar = __webpack_require__(1);

	var _fullCalendar2 = _interopRequireDefault(_fullCalendar);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var fc = _fullCalendar2.default;

	module.exports = fc;

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}

	/* styles */
	__webpack_require__(2)

	/* script */
	__vue_exports__ = __webpack_require__(6)

	/* template */
	var __vue_template__ = __webpack_require__(19)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	if (Object.keys(__vue_exports__).some(function (key) { return key !== "default" && key !== "__esModule" })) {console.error("named exports are not supported in *.vue files.")}
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.__file = "/Users/SunnyWang/code/vue-fullcalendar/src/fullCalendar.vue"
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

	/* hot reload */
	if (false) {(function () {
	  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
	  hotAPI.install(require("vue"), false)
	  if (!hotAPI.compatible) return
	  module.hot.accept()
	  if (!module.hot.data) {
	    hotAPI.createRecord("data-v-3e333dbe", __vue_options__)
	  } else {
	    hotAPI.reload("data-v-3e333dbe", __vue_options__)
	  }
	})()}
	if (__vue_options__.functional) {console.error("[vue-loader] fullCalendar.vue: functional components are not supported and should be defined in plain js files using render functions.")}

	module.exports = __vue_exports__


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(3);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/.npminstall/css-loader/0.23.1/css-loader/index.js!./../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/style-rewriter.js?id=data-v-3e333dbe!./../node_modules/.npminstall/sass-loader/3.2.3/sass-loader/index.js!./../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/selector.js?type=styles&index=0!./fullCalendar.vue", function() {
				var newContent = require("!!./../node_modules/.npminstall/css-loader/0.23.1/css-loader/index.js!./../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/style-rewriter.js?id=data-v-3e333dbe!./../node_modules/.npminstall/sass-loader/3.2.3/sass-loader/index.js!./../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/selector.js?type=styles&index=0!./fullCalendar.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports


	// module
	exports.push([module.id, "\n.comp-full-calendar {\n  padding: 20px;\n  background: #fff;\n  max-width: 960px;\n  margin: 0 auto;\n}\n.comp-full-calendar ul, .comp-full-calendar p {\n    margin: 0;\n    padding: 0;\n    font-size: 14px;\n}\n", ""]);

	// exports


/***/ },
/* 4 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];

		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};

		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];

	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}

		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();

		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

		var styles = listToStyles(list);
		addStylesToDom(styles, options);

		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}

	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}

	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}

	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}

	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}

	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}

	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}

	function addStyle(obj, options) {
		var styleElement, update, remove;

		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}

		update(obj);

		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}

	var replaceText = (function () {
		var textStore = [];

		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();

	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;

		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}

	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;

		if(media) {
			styleElement.setAttribute("media", media)
		}

		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}

	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;

		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}

		var blob = new Blob([css], { type: "text/css" });

		var oldSrc = linkElement.href;

		linkElement.href = URL.createObjectURL(blob);

		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _langSets = __webpack_require__(7);

	var _langSets2 = _interopRequireDefault(_langSets);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    events: { // events will be displayed on calendar
	      type: Array,
	      default: []
	    },
	    lang: {
	      type: String,
	      default: 'en'
	    },
	    firstDay: {
	      type: Number | String,
	      validator: function validator(val) {
	        var res = parseInt(val);
	        return res >= 0 && res <= 6;
	      },

	      default: 0
	    },
	    titleFormat: {
	      type: String,
	      default: function _default() {
	        return _langSets2.default[this.lang].titleFormat;
	      }
	    },
	    monthNames: {
	      type: Array,
	      default: function _default() {
	        return _langSets2.default[this.lang].monthNames;
	      }
	    },
	    weekNames: {
	      type: Array,
	      default: function _default() {
	        var arr = _langSets2.default[this.lang].weekNames;
	        return arr.slice(this.firstDay).concat(arr.slice(0, this.firstDay));
	      }
	    }
	  },
	  data: function data() {
	    return {
	      currentDate: new Date()
	    };
	  },

	  methods: {
	    emitChangeMonth: function emitChangeMonth(start, end, currentStart, current) {
	      console.log('currentDate 2', this.currentDate);
	      this.currentDate = current;
	      console.log('currentDate 3', this.currentDate);
	      this.$emit('changeMonth', start, end, currentStart);
	    },
	    emitEventClick: function emitEventClick(event, jsEvent, pos) {
	      this.$emit('eventClick', event, jsEvent, pos);
	    },
	    emitDayClick: function emitDayClick(day, jsEvent) {
	      this.$emit('dayClick', day, jsEvent);
	    },
	    emitMoreClick: function emitMoreClick(day, events, jsEvent) {
	      this.$emit('moreClick', day, event, jsEvent);
	    }
	  },
	  components: {
	    'fc-body': __webpack_require__(8),
	    'fc-header': __webpack_require__(14)
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    weekNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	    titleFormat: 'MMMM yyyy'
	  },
	  zh: {
	    weekNames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
	    monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
	    titleFormat: 'yyyy年MM月'
	  },
	  fr: {
	    weekNames: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
	    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
	    titleFormat: 'MMMM yyyy'
	  }
	};

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}

	/* styles */
	__webpack_require__(9)

	/* script */
	__vue_exports__ = __webpack_require__(11)

	/* template */
	var __vue_template__ = __webpack_require__(13)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	if (Object.keys(__vue_exports__).some(function (key) { return key !== "default" && key !== "__esModule" })) {console.error("named exports are not supported in *.vue files.")}
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.__file = "/Users/SunnyWang/code/vue-fullcalendar/src/components/body.vue"
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

	/* hot reload */
	if (false) {(function () {
	  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
	  hotAPI.install(require("vue"), false)
	  if (!hotAPI.compatible) return
	  module.hot.accept()
	  if (!module.hot.data) {
	    hotAPI.createRecord("data-v-734054ba", __vue_options__)
	  } else {
	    hotAPI.reload("data-v-734054ba", __vue_options__)
	  }
	})()}
	if (__vue_options__.functional) {console.error("[vue-loader] body.vue: functional components are not supported and should be defined in plain js files using render functions.")}

	module.exports = __vue_exports__


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(10);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/.npminstall/css-loader/0.23.1/css-loader/index.js!./../../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/style-rewriter.js?id=data-v-734054ba!./../../node_modules/.npminstall/sass-loader/3.2.3/sass-loader/index.js!./../../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/selector.js?type=styles&index=0!./body.vue", function() {
				var newContent = require("!!./../../node_modules/.npminstall/css-loader/0.23.1/css-loader/index.js!./../../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/style-rewriter.js?id=data-v-734054ba!./../../node_modules/.npminstall/sass-loader/3.2.3/sass-loader/index.js!./../../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/selector.js?type=styles&index=0!./body.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports


	// module
	exports.push([module.id, "\n.full-calendar-body {\n  margin-top: 20px;\n}\n.full-calendar-body .weeks {\n    display: flex;\n    border-top: 1px solid #e0e0e0;\n    border-bottom: 1px solid #e0e0e0;\n    border-left: 1px solid #e0e0e0;\n}\n.full-calendar-body .weeks .week {\n      flex: 1;\n      text-align: center;\n      border-right: 1px solid #e0e0e0;\n}\n.full-calendar-body .dates {\n    position: relative;\n}\n.full-calendar-body .dates .week-row {\n      border-left: 1px solid #e0e0e0;\n      display: flex;\n}\n.full-calendar-body .dates .week-row .day-cell {\n        flex: 1;\n        min-height: 100px;\n        padding: 4px;\n        border-right: 1px solid #e0e0e0;\n        border-bottom: 1px solid #e0e0e0;\n}\n.full-calendar-body .dates .week-row .day-cell .day-number {\n          text-align: right;\n}\n.full-calendar-body .dates .week-row .day-cell.today {\n          background-color: #fcf8e3;\n}\n.full-calendar-body .dates .week-row .day-cell.not-cur-month .day-number {\n          color: rgba(0, 0, 0, 0.24);\n}\n.full-calendar-body .dates .dates-events {\n      position: absolute;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      width: 100%;\n}\n.full-calendar-body .dates .dates-events .events-week {\n        display: flex;\n}\n.full-calendar-body .dates .dates-events .events-week .events-day {\n          cursor: pointer;\n          flex: 1;\n          min-height: 109px;\n          overflow: hidden;\n          text-overflow: ellipsis;\n}\n.full-calendar-body .dates .dates-events .events-week .events-day .day-number {\n            text-align: right;\n            padding: 4px 5px 4px 4px;\n            opacity: 0;\n}\n.full-calendar-body .dates .dates-events .events-week .events-day.not-cur-month .day-number {\n            color: rgba(0, 0, 0, 0.24);\n}\n.full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item {\n            cursor: pointer;\n            font-size: 12px;\n            background-color: #C7E6FD;\n            margin-bottom: 2px;\n            color: rgba(0, 0, 0, 0.87);\n            padding: 0 0 0 4px;\n            height: 18px;\n            line-height: 18px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n}\n.full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item.is-start {\n              margin-left: 4px;\n}\n.full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item.is-end {\n              margin-right: 4px;\n}\n.full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item.is-opacity {\n              opacity: 0;\n}\n.full-calendar-body .dates .dates-events .events-week .events-day .event-box .more-link {\n            cursor: pointer;\n            padding-left: 8px;\n            padding-right: 2px;\n            color: rgba(0, 0, 0, 0.38);\n            font-size: 14px;\n}\n.full-calendar-body .dates .more-events {\n      position: absolute;\n      width: 150px;\n      z-index: 2;\n      border: 1px solid #eee;\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n.full-calendar-body .dates .more-events .more-header {\n        background-color: #eee;\n        padding: 5px;\n        display: flex;\n        align-items: center;\n        font-size: 14px;\n}\n.full-calendar-body .dates .more-events .more-header .title {\n          flex: 1;\n}\n.full-calendar-body .dates .more-events .more-header .close {\n          margin-right: 2px;\n          cursor: pointer;\n          font-size: 16px;\n}\n.full-calendar-body .dates .more-events .more-body {\n        height: 140px;\n        overflow: hidden;\n}\n.full-calendar-body .dates .more-events .more-body .body-list {\n          height: 120px;\n          padding: 5px;\n          overflow: auto;\n          background-color: #fff;\n}\n.full-calendar-body .dates .more-events .more-body .body-list .body-item {\n            cursor: pointer;\n            font-size: 12px;\n            background-color: #C7E6FD;\n            margin-bottom: 2px;\n            color: rgba(0, 0, 0, 0.87);\n            padding: 0 0 0 4px;\n            height: 18px;\n            line-height: 18px;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n}\n", ""]);

	// exports


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _dateFunc = __webpack_require__(12);

	var _dateFunc2 = _interopRequireDefault(_dateFunc);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  props: {
	    currentDate: {},
	    events: {},
	    weekNames: {
	      type: Array,
	      default: []
	    },
	    monthNames: {},
	    firstDay: {}
	  },
	  created: function created() {
	    this.events.forEach(function (item, index) {
	      item._id = item.id || index;
	      item.end = item.end || item.start;
	    });
	    // this.events = events
	  },
	  data: function data() {
	    return {
	      // weekNames : DAY_NAMES,
	      weekMask: [1, 2, 3, 4, 5, 6, 7],
	      // events : [],
	      isLismit: true,
	      eventLimit: 3,
	      showMore: false,
	      morePos: {
	        top: 0,
	        left: 0
	      },
	      selectDay: {}
	    };
	  },

	  watch: {
	    weekNames: function weekNames(val) {
	      console.log('watch weekNames', val);
	    }
	  },
	  computed: {
	    currentDates: function currentDates() {
	      return this.getCalendar();
	    }
	  },
	  methods: {
	    isBegin: function isBegin(event, date, index) {
	      var st = new Date(event.start);

	      if (index == 0 || st.toDateString() == date.toDateString()) {
	        return event.title;
	      }
	      return '　';
	    },
	    moreTitle: function moreTitle(date) {
	      var dt = new Date(date);
	      return this.weekNames[dt.getDay()] + ', ' + this.monthNames[dt.getMonth()] + dt.getDate();
	    },
	    classNames: function classNames(cssClass) {
	      if (!cssClass) return '';
	      // string  
	      if (typeof cssClass == 'string') return cssClass;

	      // Array
	      if (Array.isArray(cssClass)) return cssClass.join(' ');

	      // else
	      return '';
	    },
	    getCalendar: function getCalendar() {
	      // calculate 2d-array of each month
	      // first day of this month
	      var now = new Date(); // today
	      var current = new Date(this.currentDate);

	      var startDate = _dateFunc2.default.getStartDate(current); // 1st day of this month

	      var curWeekDay = startDate.getDay();

	      // begin date of this table may be some day of last month
	      var diff = parseInt(this.firstDay) - curWeekDay;
	      diff = diff > 0 ? diff - 7 : diff;

	      startDate.setDate(startDate.getDate() + diff);
	      var calendar = [];

	      for (var perWeek = 0; perWeek < 6; perWeek++) {

	        var week = [];

	        for (var perDay = 0; perDay < 7; perDay++) {
	          week.push({
	            monthDay: startDate.getDate(),
	            isToday: now.toDateString() == startDate.toDateString(),
	            isCurMonth: startDate.getMonth() == current.getMonth(),
	            weekDay: perDay,
	            date: new Date(startDate),
	            events: this.slotEvents(startDate)
	          });

	          startDate.setDate(startDate.getDate() + 1);
	          // if (startDate.toDateString() == endDate.toDateString()) {
	          //   isFinal = true
	          //   break
	          // }
	        }
	        calendar.push(week);
	        // if (isFinal) break
	      }
	      return calendar;
	    },
	    slotEvents: function slotEvents(date) {

	      // find all events start from this date
	      var cellIndexArr = [];
	      var thisDayEvents = this.events.filter(function (day) {
	        var dt = new Date(day.start);
	        var st = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
	        var ed = day.end ? new Date(day.end) : st;
	        // console.log('slotEvt', st, ed, date)
	        return date >= st && date <= ed;
	      });

	      // sort by duration
	      thisDayEvents.sort(function (a, b) {
	        if (!a.cellIndex) return 1;
	        if (!b.cellIndex) return -1;
	        return a.cellIndex - b.cellIndex;
	      });

	      // mark cellIndex and place holder
	      for (var i = 0; i < thisDayEvents.length; i++) {
	        thisDayEvents[i].cellIndex = thisDayEvents[i].cellIndex || i + 1;
	        thisDayEvents[i].isShow = true;
	        if (thisDayEvents[i].cellIndex == i + 1 || i > 2) continue;
	        thisDayEvents.splice(i, 0, {
	          title: 'holder',
	          cellIndex: i + 1,
	          start: _dateFunc2.default.format(date, 'yyyy-MM-dd'),
	          end: _dateFunc2.default.format(date, 'yyyy-MM-dd'),
	          isShow: false
	        });
	      }

	      return thisDayEvents;
	    },
	    isStart: function isStart(eventDate, date) {
	      var st = new Date(eventDate);
	      return st.toDateString() == date.toDateString();
	    },
	    isEnd: function isEnd(eventDate, date) {
	      var ed = new Date(eventDate);
	      return ed.toDateString() == date.toDateString();
	    },
	    selectThisDay: function selectThisDay(day, jsEvent) {
	      this.selectDay = day;
	      this.showMore = true;
	      this.morePos = this.computePos(event.target);
	      this.morePos.top -= 100;
	      var events = day.events.filter(function (item) {
	        return item.isShow == true;
	      });
	      this.$emit('moreclick', day.date, events, jsEvent);
	    },
	    computePos: function computePos(target) {
	      var eventRect = target.getBoundingClientRect();
	      var pageRect = this.$refs.dates.getBoundingClientRect();
	      return {
	        left: eventRect.left - pageRect.left,
	        top: eventRect.top + eventRect.height - pageRect.top
	      };
	    },
	    dayClick: function dayClick(day, jsEvent) {
	      this.$emit('dayclick', day, jsEvent);
	    },
	    eventClick: function eventClick(event, jsEvent) {
	      if (!event.isShow) {
	        return;
	      }
	      jsEvent.stopPropagation();
	      var pos = this.computePos(jsEvent.target);
	      this.$emit('eventclick', event, jsEvent, pos);
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';

	var shortMonth = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var defMonthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

	var dateFunc = {
	    getDuration: function getDuration(date) {
	        // how many days of this month
	        var dt = new Date(date);
	        var month = dt.getMonth();
	        dt.setMonth(dt.getMonth() + 1);
	        dt.setDate(0);
	        return dt.getDate();
	    },
	    changeDay: function changeDay(date, num) {
	        var dt = new Date(date);
	        return new Date(dt.setDate(dt.getDate() + num));
	    },
	    getStartDate: function getStartDate(date) {
	        // return first day of this month
	        return new Date(date.getFullYear(), date.getMonth(), 1);
	    },
	    getEndDate: function getEndDate(date) {
	        // get last day of this month
	        var dt = new Date(date.getFullYear(), date.getMonth() + 1, 1); // 1st day of next month
	        return new Date(dt.setDate(dt.getDate() - 1)); // last day of this month
	    },
	    format: function format(date, _format, monthNames) {
	        monthNames = monthNames || defMonthNames;
	        if (typeof date === 'string') {
	            date = new Date(date.replace(/-/g, '/'));
	        } else {
	            date = new Date(date);
	        }

	        var map = {
	            'M': date.getMonth() + 1,
	            'd': date.getDate(),
	            'h': date.getHours(),
	            'm': date.getMinutes(),
	            's': date.getSeconds(),
	            'q': Math.floor((date.getMonth() + 3) / 3),
	            'S': date.getMilliseconds()
	        };

	        _format = _format.replace(/([yMdhmsqS])+/g, function (all, t) {
	            var v = map[t];
	            if (v !== undefined) {
	                if (all === 'MMMM') {
	                    return monthNames[v - 1];
	                }
	                if (all === 'MMM') {
	                    return shortMonth[v - 1];
	                }
	                if (all.length > 1) {
	                    v = '0' + v;
	                    v = v.substr(v.length - 2);
	                }
	                return v;
	            } else if (t === 'y') {
	                return String(date.getFullYear()).substr(4 - all.length);
	            }
	            return all;
	        });
	        return _format;
	    }
	};

	module.exports = dateFunc;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "full-calendar-body"
	  }, [_c('div', {
	    staticClass: "weeks"
	  }, _vm._l((_vm.weekNames), function(week) {
	    return _c('strong', {
	      staticClass: "week"
	    }, [_vm._v(_vm._s(week))])
	  })), _vm._v(" "), _c('div', {
	    ref: "dates",
	    staticClass: "dates"
	  }, [_c('div', {
	    staticClass: "dates-bg"
	  }, _vm._l((_vm.currentDates), function(week) {
	    return _c('div', {
	      staticClass: "week-row"
	    }, _vm._l((week), function(day) {
	      return _c('div', {
	        staticClass: "day-cell",
	        class: {
	          'today': day.isToday,
	            'not-cur-month': !day.isCurMonth
	        }
	      }, [_c('p', {
	        staticClass: "day-number"
	      }, [_vm._v(_vm._s(day.monthDay))])])
	    }))
	  })), _vm._v(" "), _c('div', {
	    staticClass: "dates-events"
	  }, _vm._l((_vm.currentDates), function(week) {
	    return _c('div', {
	      staticClass: "events-week"
	    }, _vm._l((week), function(day) {
	      return _c('div', {
	        staticClass: "events-day",
	        class: {
	          'today': day.isToday,
	            'not-cur-month': !day.isCurMonth
	        },
	        attrs: {
	          "track-by": "$index"
	        },
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            _vm.dayClick(day.date, $event)
	          }
	        }
	      }, [_c('p', {
	        staticClass: "day-number"
	      }, [_vm._v(_vm._s(day.monthDay))]), _vm._v(" "), _c('div', {
	        staticClass: "event-box"
	      }, [_vm._l((day.events), function(event) {
	        return _c('p', {
	          directives: [{
	            name: "show",
	            rawName: "v-show",
	            value: (event.cellIndex <= _vm.eventLimit),
	            expression: "event.cellIndex <= eventLimit"
	          }],
	          staticClass: "event-item",
	          class: [_vm.classNames(event.cssClass), {
	            'is-start': _vm.isStart(event.start, day.date),
	            'is-end': _vm.isEnd(event.end, day.date),
	            'is-opacity': !event.isShow
	          }],
	          on: {
	            "click": function($event) {
	              _vm.eventClick(event, $event)
	            }
	          }
	        }, [_vm._v("\n              " + _vm._s(_vm.isBegin(event, day.date, day.weekDay)) + "\n            ")])
	      }), _vm._v(" "), (day.events.length > _vm.eventLimit) ? _c('p', {
	        staticClass: "more-link",
	        on: {
	          "click": function($event) {
	            $event.stopPropagation();
	            _vm.selectThisDay(day, $event)
	          }
	        }
	      }, [_vm._v("\n              + " + _vm._s(day.events[day.events.length - 1].cellIndex - _vm.eventLimit) + " more\n            ")]) : _vm._e()], 2)])
	    }))
	  })), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showMore),
	      expression: "showMore"
	    }],
	    staticClass: "more-events",
	    style: ({
	      left: _vm.morePos.left + 'px',
	      top: _vm.morePos.top + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "more-header"
	  }, [_c('span', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.moreTitle(_vm.selectDay.date)))]), _vm._v(" "), _c('span', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.showMore = false
	      }
	    }
	  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
	    staticClass: "more-body"
	  }, [_c('ul', {
	    staticClass: "body-list"
	  }, _vm._l((_vm.selectDay.events), function(event) {
	    return _c('li', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (event.isShow),
	        expression: "event.isShow"
	      }],
	      staticClass: "body-item",
	      on: {
	        "click": function($event) {
	          _vm.eventClick(event, $event)
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(event.title) + "\n          ")])
	  }))])]), _vm._v(" "), _vm._t("body-card")], 2)])
	},staticRenderFns: []}
	module.exports.render._withStripped = true
	if (false) {
	  module.hot.accept()
	  if (module.hot.data) {
	     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-734054ba", module.exports)
	  }
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}

	/* styles */
	__webpack_require__(15)

	/* script */
	__vue_exports__ = __webpack_require__(17)

	/* template */
	var __vue_template__ = __webpack_require__(18)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	if (Object.keys(__vue_exports__).some(function (key) { return key !== "default" && key !== "__esModule" })) {console.error("named exports are not supported in *.vue files.")}
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	__vue_options__.__file = "/Users/SunnyWang/code/vue-fullcalendar/src/components/header.vue"
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

	/* hot reload */
	if (false) {(function () {
	  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
	  hotAPI.install(require("vue"), false)
	  if (!hotAPI.compatible) return
	  module.hot.accept()
	  if (!module.hot.data) {
	    hotAPI.createRecord("data-v-62863025", __vue_options__)
	  } else {
	    hotAPI.reload("data-v-62863025", __vue_options__)
	  }
	})()}
	if (__vue_options__.functional) {console.error("[vue-loader] header.vue: functional components are not supported and should be defined in plain js files using render functions.")}

	module.exports = __vue_exports__


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag

	// load the styles
	var content = __webpack_require__(16);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(5)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/.npminstall/css-loader/0.23.1/css-loader/index.js!./../../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/style-rewriter.js?id=data-v-62863025!./../../node_modules/.npminstall/sass-loader/3.2.3/sass-loader/index.js!./../../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/selector.js?type=styles&index=0!./header.vue", function() {
				var newContent = require("!!./../../node_modules/.npminstall/css-loader/0.23.1/css-loader/index.js!./../../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/style-rewriter.js?id=data-v-62863025!./../../node_modules/.npminstall/sass-loader/3.2.3/sass-loader/index.js!./../../node_modules/.npminstall/vue-loader/10.0.2/vue-loader/lib/selector.js?type=styles&index=0!./header.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(4)();
	// imports


	// module
	exports.push([module.id, "\n.full-calendar-header {\n  display: flex;\n  align-items: center;\n}\n.full-calendar-header .header-left, .full-calendar-header .header-right {\n    flex: 1;\n}\n.full-calendar-header .header-center {\n    flex: 3;\n    text-align: center;\n}\n.full-calendar-header .header-center .title {\n      margin: 0 10px;\n}\n.full-calendar-header .header-center .prev-month, .full-calendar-header .header-center .next-month {\n      cursor: pointer;\n}\n", ""]);

	// exports


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _dateFunc = __webpack_require__(12);

	var _dateFunc2 = _interopRequireDefault(_dateFunc);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = {
	  created: function created() {
	    this.dispatchEvent();
	  },

	  props: {
	    currentDate: {},
	    titleFormat: {},
	    firstDay: {},
	    monthNames: {}
	  },
	  data: function data() {
	    return {
	      title: '',
	      leftArrow: '<',
	      rightArrow: '>',
	      headDate: new Date()
	    };
	  },

	  watch: {
	    currentDate: function currentDate(val) {
	      if (!val) return;
	      this.headDate = val;
	      console.log('currentDate', val);
	      // this.headDate = JSON.parse(JSON.stringify(val))
	    }
	  },
	  methods: {
	    goPrev: function goPrev() {
	      this.headDate = this.changeMonth(this.headDate, -1);
	      this.dispatchEvent();
	    },
	    goNext: function goNext() {
	      this.headDate = this.changeMonth(this.headDate, 1);
	      this.dispatchEvent();
	    },
	    changeMonth: function changeMonth(date, num) {
	      var dt = new Date(date);
	      return new Date(dt.setMonth(dt.getMonth() + num));
	    },
	    dispatchEvent: function dispatchEvent() {
	      this.title = _dateFunc2.default.format(this.headDate, this.titleFormat, this.monthNames);

	      var startDate = _dateFunc2.default.getStartDate(this.headDate);
	      var curWeekDay = startDate.getDay();

	      // 1st day of this monthView
	      var diff = parseInt(this.firstDay) - curWeekDay;
	      if (diff) diff -= 7;
	      startDate.setDate(startDate.getDate() + diff);

	      // the month view is 6*7
	      var endDate = _dateFunc2.default.changeDay(startDate, 41);

	      // 1st day of current month
	      var currentDate = _dateFunc2.default.getStartDate(this.headDate);

	      this.$emit('change', _dateFunc2.default.format(startDate, 'yyyy-MM-dd'), _dateFunc2.default.format(endDate, 'yyyy-MM-dd'), _dateFunc2.default.format(currentDate, 'yyyy-MM-dd'), this.headDate);
	    }
	  }
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "full-calendar-header"
	  }, [_c('div', {
	    staticClass: "header-left"
	  }, [_vm._t("header-left")], 2), _vm._v(" "), _c('div', {
	    staticClass: "header-center"
	  }, [_c('span', {
	    staticClass: "prev-month",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.goPrev($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.leftArrow))]), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
	    staticClass: "next-month",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.goNext($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.rightArrow))])]), _vm._v(" "), _c('div', {
	    staticClass: "header-right"
	  }, [_vm._t("header-right")], 2)])
	},staticRenderFns: []}
	module.exports.render._withStripped = true
	if (false) {
	  module.hot.accept()
	  if (module.hot.data) {
	     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-62863025", module.exports)
	  }
	}

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
	  return _c('div', {
	    staticClass: "comp-full-calendar"
	  }, [_c('fc-header', {
	    attrs: {
	      "current-date": _vm.currentDate,
	      "title-format": _vm.titleFormat,
	      "first-day": _vm.firstDay,
	      "month-names": _vm.monthNames
	    },
	    on: {
	      "change": _vm.emitChangeMonth
	    }
	  }, [_c('div', {
	    slot: "header-left"
	  }, [_vm._t("fc-header-left")], 2), _vm._v(" "), _c('div', {
	    slot: "header-right"
	  }, [_vm._t("fc-header-right")], 2)]), _vm._v(" "), _c('fc-body', {
	    attrs: {
	      "current-date": _vm.currentDate,
	      "events": _vm.events,
	      "month-names": _vm.monthNames,
	      "week-names": _vm.weekNames,
	      "first-day": _vm.firstDay
	    },
	    on: {
	      "eventclick": _vm.emitEventClick,
	      "dayclick": _vm.emitDayClick,
	      "moreclick": _vm.emitMoreClick
	    }
	  }, [_c('div', {
	    slot: "body-card"
	  }, [_vm._t("fc-body-card")], 2)])], 1)
	},staticRenderFns: []}
	module.exports.render._withStripped = true
	if (false) {
	  module.hot.accept()
	  if (module.hot.data) {
	     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3e333dbe", module.exports)
	  }
	}

/***/ }
/******/ ])
});
;

/***/ }),

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1128),
  /* template */
  __webpack_require__(1219),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FileUploadComponent__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FileUploadComponent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FileUploadComponent__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_2__FileUploadComponent___default.a
  },
  data: function data() {
    return {
      activityPhotoUploaded: false,
      activityPhotoFile: "",
      activityPhotoFileName: "",
      activityPhotoFileURL: "",
      content: "",
      dynamicrows: 1,
      activeActivityForm: "tab-1"
    };
  },
  mounted: function mounted() {
    this.activeActivityForm = "tab-1";
  },
  props: ["firstname", "type", "extraData", "extraUrl"],
  computed: {
    company: function company() {
      return this.$store.getters.getCompanyDetails;
    },
    companyVerified: function companyVerified() {
      return this.company.verified;
    },
    companyAdded: function companyAdded() {
      return this.company.otherinfo;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  methods: {
    validateVideoUrl: function validateVideoUrl(text) {
      var type = null;
      var embedUrl = null;
      text.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/); // eslint-disable-line

      if (RegExp.$3.indexOf("youtu") > -1) {
        type = "youtube";
        embedUrl = "https://www.youtube.com/embed/".concat(RegExp.$6, "?autoplay=0");
      } else if (RegExp.$3.indexOf("vimeo") > -1) {
        type = "vimeo";
        embedUrl = "https://player.vimeo.com/video/".concat(RegExp.$6, "?color=ef0000");
      }

      if (!type) {
        return undefined;
      }

      return {
        type: type,
        id: RegExp.$6,
        embedUrl: embedUrl
      };
    },
    removeAlert: function removeAlert() {
      document.getElementById("alert-div-post").style.display = "none";
    },
    showActivityPhoto: function showActivityPhoto() {
      if (FileReader && this.activityPhotoFile && this.activityPhotoFile.length) {
        var fr = new FileReader();

        fr.onload = function () {
          this.activityPhotoFileURL = fr.result;
          document.getElementById("imgActivity").src = fr.result;
        };

        fr.readAsDataURL(this.activityPhotoFile[0]);
      } else {}

      this.activityPhotoFileName = this.activityPhotoFile[0].name;
      this.activityPhotoUploaded = false;
    },
    cancelActivityPhoto: function cancelActivityPhoto() {
      this.activityPhotoUploaded = false;
      this.activityPhotoFile = "";
      this.activityPhotoFileName = "";
      this.activityPhotoFileURL = "";
    },
    submit: function submit() {
      var el = document.getElementById("addacommText");
      setTimeout(function () {
        el.style.cssText = "height:auto; padding:0";
        el.style.cssText = "height:" + el.scrollHeight + "px";
      }, 0);
    },
    postActivity: function postActivity() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var self, snackbar, newPostKey, storageRef, attachmentRef, _snackbar, attachmentUrl, _snackbar2, video, post, _snackbar3, el, _snackbar4;

        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;

                if (!(_this.content === "")) {
                  _context.next = 5;
                  break;
                }

                snackbar = {
                  active: true,
                  text: "Please enter something"
                };

                _this.$store.dispatch("triggerSnackbar", snackbar);

                return _context.abrupt("return", null);

              case 5:
                newPostKey = _this.$firebase.database().ref().child("".concat(self.type).concat(self.extraUrl)).push().key;
                storageRef = _this.$firebase.storage().ref();
                attachmentRef = storageRef.child("".concat(self.type).concat(self.extraUrl, "/").concat(newPostKey, "/attachment.jpg"));
                _context.prev = 8;

                if (!(_this.activityPhotoFileName !== "")) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return attachmentRef.put(_this.activityPhotoFile[0]);

              case 12:
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](8);
                _snackbar = {
                  active: true,
                  text: _context.t0.message
                };

                _this.$store.dispatch("triggerSnackbar", _snackbar);

                return _context.abrupt("return", null);

              case 19:
                attachmentUrl = "";
                _context.prev = 20;

                if (!(_this.activityPhotoFileName !== "")) {
                  _context.next = 25;
                  break;
                }

                _context.next = 24;
                return storageRef.child("".concat(self.type).concat(self.extraUrl, "/").concat(newPostKey, "/attachment.jpg")).getDownloadURL();

              case 24:
                attachmentUrl = _context.sent;

              case 25:
                _context.next = 32;
                break;

              case 27:
                _context.prev = 27;
                _context.t1 = _context["catch"](20);
                _snackbar2 = {
                  active: true,
                  text: _context.t1.message
                };

                _this.$store.dispatch("triggerSnackbar", _snackbar2);

                return _context.abrupt("return", null);

              case 32:
                video = null;

                if (_this.validateVideoUrl(_this.content)) {
                  video = _this.validateVideoUrl(_this.content);
                }

                post = {
                  posteddate: 1 * new Date().getTime(),
                  uid: _this.user.uid,
                  video: video,
                  content: _this.content,
                  attachmentUrl: attachmentUrl,
                  approvalStatus: 0,
                  approvaldate: ""
                };
                Object.assign(post, self.extraData);
                _context.prev = 36;
                _context.next = 39;
                return _this.$firebase.database().ref("".concat(self.type).concat(self.extraUrl, "/").concat(newPostKey)).setWithPriority(post, 1 * Date.now());

              case 39:
                _this.content = "";

                _this.cancelActivityPhoto();

                _snackbar3 = {
                  active: true,
                  text: "Post was created successfully, but needs to be approved by the admin"
                };
                _context.next = 44;
                return _this.$store.dispatch("sendNotification", {
                  type: "request",
                  action: "newsfeed_post"
                });

              case 44:
                el = document.getElementById("addacommText");
                setTimeout(function () {
                  el.style.cssText = "height:auto; padding:0";
                  el.style.cssText = "height:30px";
                }, 0);

                _this.$store.dispatch("triggerSnackbar", _snackbar3);

                _context.next = 54;
                break;

              case 49:
                _context.prev = 49;
                _context.t2 = _context["catch"](36);
                _snackbar4 = {
                  active: true,
                  text: _context.t2.message
                };

                _this.$store.dispatch("triggerSnackbar", _snackbar4);

                return _context.abrupt("return", null);

              case 54:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 14], [20, 27], [36, 49]]);
      }))();
    }
  }
};

/***/ }),

/***/ 1124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_AvatarPopup__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ui_AvatarPopup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ui_AvatarPopup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mdi_css_materialdesignicons_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mdi_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mdi_css_materialdesignicons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var db = __WEBPACK_IMPORTED_MODULE_4_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['item', 'itemKey', 'type', 'extraUrl'],
  components: {
    AvatarPopup: __WEBPACK_IMPORTED_MODULE_1__components_ui_AvatarPopup___default.a
  },
  data: function data() {
    return {
      anArray: {},
      comment: '',
      showComments: false,
      allowPin: false,
      count: 0,
      items: [],
      feed: [],
      user: this.getUserDetails,
      companyInformation: {},
      divcount: 0,
      comments: []
    };
  },
  firebase: function firebase() {
    return {
      fetchLikes: db.ref("".concat(this.type).concat(this.extraUrl, "/").concat(this.itemKey)).child('likes'),
      getComments: db.ref("".concat(this.type).concat(this.extraUrl, "/").concat(this.itemKey)).child('comments')
    };
  },
  mounted: function mounted() {
    this.getUserComments;
  },
  computed: _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getUserDetails'])), {}, {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    isAdmin: function isAdmin() {
      if (this.$store.getters.getUserDetails.role === 1) {
        return true;
      }

      return false;
    },
    itemRssFeedCategories: function itemRssFeedCategories() {
      var categories = [];

      if (this.item.type && this.item.type === 'rss') {
        categories = this.item.categories.map(function (category) {
          return "#".concat(category.replace(' ', '-')).toLowerCase();
        });
        return categories;
      }
    },
    likes: function likes() {
      var values = [];
      this.fetchLikes.forEach(function (item, index) {
        values.push(item['.value']);
      });
      return values;
    },
    getUserComments: function getUserComments() {
      var self = this;
      return this.$firebaseRefs.getComments.on('value', function (result) {
        if (result.val()) {
          var commentKeys = Object.keys(result.val());

          var userIds = self._.uniq(commentKeys.map(function (comment) {
            return result.val()[comment].uid;
          }));

          var userInfo = userIds.map(function (id) {
            return self.$firebase.database().ref('users/' + id).once('value');
          });
          Promise.all(userInfo).then(function (users) {
            self.comments = [];
            users.forEach(function (user) {
              commentKeys.forEach(function (comment) {
                if (result.val()[comment].uid === user.val().uid) {
                  var item = result.val()[comment];
                  item.commetId = comment;
                  item.user = {};
                  Object.assign(item.user, user.val());
                  self.comments.push(item);
                }
              });
            });
          });
        } else {
          self.comments = [];
        }
      });
    }
  }),
  methods: {
    pinPost: function pinPost() {
      var self = this;
      var pinnedItem = this.item.postKey;
      this.$firebase.database().ref('pinnedPost').once('value', function (snapshot) {
        var postId = snapshot.val();

        if (postId) {
          return self.$firebase.database().ref("posts/".concat(pinnedItem, "/pinned")).set(true).then(function () {
            return self.$firebase.database().ref('pinnedPost').set(pinnedItem).then(function () {
              setTimeout(function () {
                return self.$firebase.database().ref("posts/".concat(postId, "/pinned")).set(null);
              }, 3000);
            });
          });
        }

        return self.$firebase.database().ref("posts/".concat(pinnedItem, "/pinned")).set(true).then(function () {
          return self.$firebase.database().ref('pinnedPost').set(pinnedItem);
        });
      });
    },
    removePin: function removePin() {
      var self = this;
      this.$firebase.database().ref('pinnedPost').once('value', function (snapshot) {
        var postId = snapshot.val();
        return self.$firebase.database().ref("posts/".concat(postId, "/pinned")).set(null).then(function () {
          return self.$firebase.database().ref('pinnedPost').set(null);
        });
      });
    },
    timelineLink: function timelineLink(link) {
      return encodeURI("".concat(window.location.protocol, "//").concat(window.location.host, "/r/?to=").concat(link));
    },
    likePost: function likePost(item, key) {
      this.$firebase.database().ref("".concat(this.type).concat(this.extraUrl, "/").concat(item.postKey, "/likes/").concat(this.getUserDetails.uid)).set(this.getUserDetails.uid);
    },
    unLikePost: function unLikePost(item, key) {
      this.$firebase.database().ref("".concat(this.type).concat(this.extraUrl, "/").concat(item.postKey, "/likes/").concat(this.getUserDetails.uid)).remove();
    },
    postComment: function postComment(postKey) {
      if (this.comment === '') {
        var snackbar = {
          active: true,
          text: 'Please enter something'
        };
        this.$store.dispatch('triggerSnackbar', snackbar);
        return null;
      }

      var self = this;
      var comment = {
        uid: this.getUserDetails.uid,
        comment: this.comment,
        date: Date.now()
      };
      this.$firebase.database().ref("".concat(this.type).concat(this.extraUrl, "/").concat(postKey, "/comments")).push(comment);
      this.comment = '';
    },
    toggleComments: function toggleComments() {
      if (this.showComments) {
        this.showComments = false;
        return false;
      }

      this.showComments = true;
      return true;
    }
  }
};

/***/ }),

/***/ 1126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_fullcalendar__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_fullcalendar__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['dialog'],
  components: {
    FullCalendar: __WEBPACK_IMPORTED_MODULE_0_vue_fullcalendar___default.a
  },
  watch: {
    dialog: function dialog(val) {
      this.trigger = val;
    },
    trigger: function trigger(val) {
      if (!val) {
        this.$parent.$emit('cancel');
      }
    }
  },
  methods: {
    closeModal: function closeModal() {
      this.$parent.$emit('cancel');
    }
  },
  data: function data() {
    return {
      events: [],
      trigger: this.$props.dialog,
      items: [],
      count: 0
    };
  },
  mounted: function mounted() {
    var self = this;
    this.$firebase.database().ref("events").orderByChild('submitdate').limitToFirst(5).once('value').then(function (snap) {
      snap.forEach(function (childSnapshot) {
        var childKey = childSnapshot.key;
        var childData = childSnapshot.val();

        if (childData.approvalStatus === 1) {
          self.items.push({
            title: childData.title,
            start: childData.eventdate
          });
          self.items[self.count]['postKey'] = childKey;
        }
      });
      self.events = self.items;
    });
  }
};

/***/ }),

/***/ 1128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['targetElement', 'item', 'uid'],
  data: function data() {
    return {
      positionStyle: {}
    };
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  methods: {
    openChat: function openChat(uid) {
      window.$applozic.fn.applozic('loadTab', uid);
      $('html').addClass('sidebox-open');
    }
  }
};

/***/ }),

/***/ 1142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ShareButton_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ShareButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ShareButton_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    ShareButton: __WEBPACK_IMPORTED_MODULE_0__components_ShareButton_vue___default.a
  },
  props: ['event', 'type'],
  mounted: function mounted() {
    this.getFavourited;
  },
  data: function data() {
    return {
      favorited: false,
      seen: false
    };
  },
  methods: {
    copyToClipboard: function copyToClipboard(link) {
      var self = this;
      this.$copyText(link).then(function (e) {
        var snackbar = {
          active: true,
          text: 'Link Successfully Copied To Clipboard'
        };
        self.$store.dispatch('triggerSnackbar', snackbar);
        setTimeout(function () {
          var snackbar = {
            active: false,
            text: ''
          };
          self.$store.dispatch('triggerSnackbar', snackbar);
        }, 2000);
      }, function (e) {
        var snackbar = {
          active: true,
          text: 'Unable To Copy Link To Clipboard'
        };
        self.$store.dispatch('triggerSnackbar', snackbar);
      });
    },
    viewEvent: function viewEvent(event) {
      this.$emit('viewEvent', event);
    },
    showlistTrigger: function showlistTrigger() {
      self = this;
      self.showlist = true;
    },
    favoriteItem: function favoriteItem() {
      var favoritePayload = {
        uid: this.userDetails.uid
      };
      var self = this;
      self.favorited = true;
      this.$firebase.database().ref("favorites/".concat(this.type, "/").concat(this.userDetails.uid, "/").concat(this.event.eventKey)).set(favoritePayload);
    },
    unfavoriteItem: function unfavoriteItem() {
      var self = this;
      self.favorited = false;
      this.$firebase.database().ref("favorites/".concat(this.type, "/").concat(this.userDetails.uid, "/").concat(this.event.eventKey)).set(null);
    }
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    userDetails: function userDetails() {
      return this.$store.getters.getUserDetails;
    },
    getFavourited: function getFavourited() {
      var self = this;
      this.$firebase.database().ref("favorites/".concat(this.type, "/").concat(this.userDetails.uid, "/").concat(this.event.eventKey)).on('value', function (snapshot) {
        if (!snapshot.val()) {
          self.favorited = false;
        } else {
          self.favorited = true;
        }
      });
    },
    link: function link() {
      var link = "https://".concat(window.location.host, "/events#id=").concat(this.event.eventKey);
      return link;
    }
  }
};

/***/ }),

/***/ 1153:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".avatar-popup-menu .avatar-popup-action{background:#fff;padding:0 10px 10px}.avatar-popup-menu .avatar-popup-action .btn{margin:0;width:100%}", "", {"version":3,"sources":["/home/circleci/repo/src/components/ui/AvatarPopup.vue"],"names":[],"mappings":"AACA,wCACE,gBAAiB,AACjB,mBAA0B,CAC3B,AACD,6CACE,SAAU,AACV,UAAY,CACb","file":"AvatarPopup.vue","sourcesContent":["\n.avatar-popup-menu .avatar-popup-action {\n  background: #fff;\n  padding: 0 10px 10px 10px;\n}\n.avatar-popup-menu .avatar-popup-action .btn {\n  margin: 0;\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1155:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".share_list{position:absolute;top:0}.layout.wrap{position:relative}.share_list a{height:auto;font-size:12px;color:#666}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/grouppage/events/EventTimelineComponent.vue"],"names":[],"mappings":"AACA,YACE,kBAAmB,AACnB,KAAO,CACR,AACD,aACE,iBAAmB,CACpB,AACD,cACE,YAAY,AACZ,eAAgB,AAChB,UAAY,CACb","file":"EventTimelineComponent.vue","sourcesContent":["\n.share_list{\n  position: absolute;\n  top: 0;\n}\n.layout.wrap{\n  position: relative;\n}\n.share_list a{\n  height:auto;\n  font-size: 12px;\n  color: #666;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1156:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "#imgActivity{height:100px;padding:15px;margin:5px;border:2px dotted #dcdcdc}#close{float:left;padding:5px}", "", {"version":3,"sources":["/home/circleci/repo/src/components/CreateActivityComponent.vue"],"names":[],"mappings":"AACA,aAGE,aAAc,AACd,aAAc,AACd,WAAY,AACZ,yBAAwB,CACzB,AACD,OACE,WAAY,AACZ,WAAiB,CAClB","file":"CreateActivityComponent.vue","sourcesContent":["\n#imgActivity {\n  border-style: dotted;\n  border-width: 2px;\n  height: 100px;\n  padding: 15px;\n  margin: 5px;\n  border-color: gainsboro;\n}\n#close {\n  float: left;\n  padding: 5px 5px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1163:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".background-image{background-position-y:center;background-size:cover;background-repeat:no-repeat;top:0;left:0;right:0;height:100%;bottom:0}.icon-red i{color:#ff1b00!important}.icon-blue i{color:#0388d1!important}.com-like{background:#424242;color:#fff;padding-top:6px;border-radius:0 20px 20px 0;padding-right:17px;padding-bottom:6px}.hidden{display:none}.rss-feed-image{width:100%;height:200px;background-position:50%}", "", {"version":3,"sources":["/home/circleci/repo/src/components/Timeline.vue"],"names":[],"mappings":"AACA,kBACE,6BAA8B,AAC9B,sBAAuB,AACvB,4BAA6B,AAC7B,MAAO,AACP,OAAQ,AACR,QAAS,AACT,YAAa,AACb,QAAU,CACX,AACD,YACE,uBAA0B,CAC3B,AACD,aACE,uBAA0B,CAC3B,AACD,UACE,mBAA4B,AAC5B,WAAY,AACZ,gBAAiB,AACjB,4BAAiC,AACjC,mBAAoB,AACpB,kBAAoB,CACrB,AACD,QACE,YAAc,CACf,AACD,gBACE,WAAY,AACZ,aAAc,AACd,uBAA2B,CAC5B","file":"Timeline.vue","sourcesContent":["\n.background-image {\n  background-position-y: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  bottom: 0;\n}\n.icon-red i {\n  color: #ff1b00 !important;\n}\n.icon-blue i {\n  color: #0388d1 !important;\n}\n.com-like {\n  background: rgb(66, 66, 66);\n  color: #fff;\n  padding-top: 6px;\n  border-radius: 0px 20px 20px 0px;\n  padding-right: 17px;\n  padding-bottom: 6px;\n}\n.hidden {\n  display: none;\n}\n.rss-feed-image {\n  width: 100%;\n  height: 200px;\n  background-position:center;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1175:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1153);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("77f2dc1c", content, true, {});

/***/ }),

/***/ 1177:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1155);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("75b742e1", content, true, {});

/***/ }),

/***/ 1178:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1156);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("6d89e424", content, true, {});

/***/ }),

/***/ 1185:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1163);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("fe2c87fe", content, true, {});

/***/ }),

/***/ 1194:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1178)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1123),
  /* template */
  __webpack_require__(1223),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1195:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1185)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1124),
  /* template */
  __webpack_require__(1230),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1197:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1126),
  /* template */
  __webpack_require__(1224),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1212:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1177)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1142),
  /* template */
  __webpack_require__(1221),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1219:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avatar-popup-menu"
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "alt": _vm.item && _vm.item.user && _vm.item.user.avatar ? _vm.item.user.avatar : 'default-avatar.gif',
      "src": _vm.item && _vm.item.user && _vm.item.user.avatar ? _vm.item.user.avatar : __webpack_require__(1065)
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "900",
      "text-transform": "capitalize"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_vm._v(_vm._s(_vm.item.user.firstname + ' ' + _vm.item.user.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('div', {
    staticStyle: {
      "color": "#000",
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.item.user.jobtitle) + " "), (_vm.item.user.jobtitle && _vm.item.company) ? _c('span', [_vm._v("|\n              " + _vm._s(_vm.item.company.companylegalname))]) : _vm._e()])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "avatar-popup-action"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.openChat(_vm.uid)
      }
    }
  }, [_vm._v("Message")])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1221:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    staticClass: "ml-2 event-info",
    staticStyle: {
      "height": "100%",
      "min-height": "150px"
    },
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "event-image-flex",
    attrs: {
      "xs3": "",
      "sm2": "",
      "md1": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "15px"
    }
  }, [_c('img', {
    staticClass: "event-image",
    staticStyle: {
      "border-radius": "15px",
      "height": "100px",
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.event.logo || '/static/images/event-icon.png'
    }
  })])]), _vm._v(" "), _c('v-flex', {
    staticClass: "event-content",
    attrs: {
      "xs9": "",
      "sm10": "",
      "md6": "",
      "lg7": "",
      "pl-3": ""
    }
  }, [_c('h5', {
    staticClass: "secondary--text event-name",
    staticStyle: {
      "font-weight": "900",
      "cursor": "pointer",
      "font-size": "17px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.viewEvent(_vm.event)
      }
    }
  }, [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), _c('div', {
    staticClass: "event-date date_range"
  }, [_c('b', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm._f("actualDate")(_vm.event.eventdate)) + " " + _vm._s(_vm._f("formatTime")(_vm.event.starteventtime)) + " - " + _vm._s(_vm._f("formatTime")(_vm.event.endeventtime)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Registration Deadline:")]), _vm._v(" " + _vm._s(_vm.event.deadline || 'N/A') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Fee:")]), _vm._v(" " + _vm._s(_vm.event.fee || 'N/A') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Center:")]), _vm._v(" " + _vm._s(_vm.event.center || 'N/A') + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "hidden-sm-and-down"
  }, [_c('b', [_vm._v("Point of Contact:")]), _vm._v(" " + _vm._s(_vm.event.pointofcontact || 'N/A') + "\n        ")]), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-left": "-13px"
    },
    attrs: {
      "row": "",
      "hidden-md-and-up": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.event.link,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "small": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("date_range")]), _vm._v("\n                RSVP\n              ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [(!_vm.favorited) ? _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1) : _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    on: {
      "click": function($event) {
        _vm.seen = !_vm.seen
      }
    }
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "text": "Share",
      "size": "16px",
      "link": _vm.link
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "xs3": "",
      "sm4": "",
      "md5": "",
      "lg4": "",
      "hidden-sm-and-down": "",
      "align-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": _vm.event.link,
      "target": "_blank"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "text-transform": "capitalize"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("date_range")]), _vm._v("\n                RSVP\n              ")], 1)], 1)], 1)]), _vm._v(" "), _c('v-flex', [(!_vm.favorited) ? _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1) : _c('v-btn', {
    staticStyle: {
      "height": "auto"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "flat": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": "",
      "color": "red"
    }
  }, [_vm._v("favorite")]), _vm._v("\n                Favorite\n              ")], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    on: {
      "click": function($event) {
        _vm.seen = !_vm.seen
      }
    }
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "text": "Share",
      "size": "40px",
      "link": _vm.link
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider', {
    staticClass: "mt-2"
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1223:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-form', {}, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "display": "table-cell"
    },
    attrs: {
      "xs12": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-0 pb-0"
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md7": ""
    }
  }, [_c('v-tabs', {
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px"
    },
    attrs: {
      "slider-color": "primary",
      "grow": ""
    },
    model: {
      value: (_vm.activeActivityForm),
      callback: function($$v) {
        _vm.activeActivityForm = $$v
      },
      expression: "activeActivityForm"
    }
  }, [_c('v-tab', {
    key: "tab-1",
    staticClass: "white",
    attrs: {
      "dark": "",
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "color": "#000",
      "font-size": "19px",
      "font-weight": "900"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("create")]), _vm._v("Share an update\n                ")], 1)]), _vm._v(" "), _c('v-tab', {
    key: "tab-2",
    attrs: {
      "href": '#tab-2'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.activityPhotoUploaded = true
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "color": "#000",
      "font-size": "19px",
      "font-weight": "900"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("insert_photo")]), _vm._v("Upload a photo\n                ")], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "margin-top": "0px",
      "padding": "0px"
    },
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs11": ""
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "padding-bottom": "0px",
      "height": "100%"
    },
    attrs: {
      "multi-line": "",
      "full-width": "",
      "auto-grow": "",
      "rows": _vm.dynamicrows,
      "placeholder": "What's on your mind?",
      "id": "addacommText"
    },
    on: {
      "keydown": _vm.submit
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "float": "right",
      "padding-right": "0px"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "float": "right",
      "font-size": "22px",
      "margin-right": "0px",
      "font-weight": "900"
    },
    attrs: {
      "large": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.postActivity()
      }
    }
  }, [_vm._v("POST")])], 1)], 1), _vm._v(" "), _c('file-upload', {
    attrs: {
      "trigger": _vm.activityPhotoUploaded,
      "formats": ['jpeg', 'png', 'jpg']
    },
    on: {
      "cancel": function($event) {
        _vm.activityPhotoUploaded = false;
        _vm.activityPhotoFile = ''
      },
      "confirm": function($event) {
        return _vm.showActivityPhoto()
      }
    },
    model: {
      value: (_vm.activityPhotoFile),
      callback: function($$v) {
        _vm.activityPhotoFile = $$v
      },
      expression: "activityPhotoFile"
    }
  })], 1), _vm._v(" "), (_vm.activityPhotoFile != '') ? _c('v-card', {
    staticClass: "mt-0 pt-0"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "id": "close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelActivityPhoto()
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("close")])], 1), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.activityPhotoFileURL,
      "id": "imgActivity"
    }
  })], 1)]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "load-data-div",
    attrs: {
      "xs12": "",
      "md12": "",
      "id": "alert-div-post"
    }
  }, [_c('v-alert', {
    staticClass: "post-msg",
    attrs: {
      "success": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeAlert()
      }
    }
  }, [_vm._v("\n      Post has been submitted for review\n      "), _c('a', {
    staticClass: "close-btn",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("X")])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1224:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": 1000
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.closeModal.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.trigger),
      callback: function($$v) {
        _vm.trigger = $$v
      },
      expression: "trigger"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pt-0 pb-0"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeModal.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("cancel")])], 1)], 1)]), _vm._v(" "), _c('full-calendar', {
    attrs: {
      "events": _vm.events,
      "locale": "en"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    staticClass: "my-3",
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.item.pinned) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "left": "-11px",
      "top": "-11px",
      "z-index": "1",
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "slot": "activator",
      "color": "secondary",
      "dark": "",
      "absolute": "",
      "small": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        _vm.allowPin = true
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("fa-thumb-tack")])], 1), _vm._v(" "), _c('span', [_vm._v("Pin post")])], 1) : (_vm.item.pinned) ? _c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    staticStyle: {
      "left": "-11px",
      "top": "-11px",
      "z-index": "1",
      "width": "30px",
      "height": "30px"
    },
    attrs: {
      "slot": "activator",
      "color": "red",
      "dark": "",
      "absolute": "",
      "small": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.removePin()
      }
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("fa-thumb-tack")])], 1), _vm._v(" "), _c('span', [_vm._v("Unpin post")])], 1) : _vm._e(), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "max-width": "300",
      "min-width": "250",
      "z-index": "1",
      "bottom": "",
      "nudge-bottom": 30,
      "nudge-top": -20,
      "nudge-left": 10
    }
  }, [_c('v-list-tile-avatar', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('img', {
    attrs: {
      "alt": "User avatar",
      "src": _vm.item && _vm.item.user && _vm.item.user.avatar ? _vm.item.user.avatar : __webpack_require__(1065)
    }
  })]), _vm._v(" "), _c('avatar-popup', {
    attrs: {
      "item": _vm.item,
      "uid": _vm.item.uid
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "900",
      "text-transform": "capitalize"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_vm._v(_vm._s(_vm.item.user.firstname + ' ' + _vm.item.user.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('div', {
    staticStyle: {
      "color": "#000",
      "font-size": "15px"
    }
  }, [_vm._v(_vm._s(_vm.item.user.jobtitle) + " "), (_vm.item.user.jobtitle && _vm.item.company) ? _c('span', [_vm._v("| " + _vm._s(_vm.item.company.companylegalname))]) : _vm._e()])])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.likes.includes(_vm.getUserDetails.uid)) ? _c('v-icon', {
    staticClass: "secondary--text",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unLikePost(_vm.item, _vm.itemKey)
      }
    }
  }, [_vm._v("fa-thumbs-up")]) : _c('v-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.likePost(_vm.item, _vm.itemKey)
      }
    }
  }, [_vm._v("fa-thumbs-o-up")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3 mb-3"
  }, [(!_vm.item.type) ? _c('span', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_vm._v(_vm._s(_vm.item.content))]) : _vm._e(), _vm._v(" "), (_vm.item.type && _vm.item.type === 'rss') ? _c('div', {
    staticStyle: {
      "white-space": "pre-wrap"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_vm._v(_vm._s(_vm.item.content))]), _vm._v(" "), (_vm.item.link) ? _c('div', {
    staticClass: "mt-1"
  }, [_c('a', {
    attrs: {
      "rel": "noopener",
      "href": _vm.timelineLink(_vm.item.link),
      "target": "_blank"
    }
  }, [_vm._v("Link to article")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_vm._v(_vm._s(_vm.itemRssFeedCategories.join(' ')))])]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.item.video) ? _c('v-flex', {
    class: {
      'xs12': true, 'md6': _vm.item.video && _vm.item.attachmentUrl, 'md12': _vm.item.video && !_vm.item.attachmentUrl
    }
  }, [_c('iframe', {
    staticStyle: {
      "width": "100%",
      "height": "260px",
      "border": "0px"
    },
    attrs: {
      "allowfullscreen": "",
      "src": _vm.item.video.embedUrl
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.item.attachmentUrl) ? _c('v-flex', {
    staticClass: "text-xs-center",
    class: {
      'xs12': true, 'md6': _vm.item.attachmentUrl && _vm.item.video, 'md12': _vm.item.attachmentUrl && !_vm.item.video
    }
  }, [(_vm.item.type && _vm.item.type === 'rss') ? _c('div', {
    staticClass: "rss-feed-image",
    style: ({
      backgroundImage: ("url(" + (_vm.item.attachmentUrl.replace('http:', 'https:')) + ")")
    })
  }) : _vm._e(), _vm._v(" "), (!_vm.item.type) ? _c('img', {
    staticClass: "py-2",
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "alt": "Post Image",
      "src": _vm.item.attachmentUrl.replace('http:', 'https:')
    }
  }) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "font-size": "13px"
    },
    attrs: {
      "md12": ""
    }
  }, [_c('v-subheader', {
    staticClass: "pl-0"
  }, [_c('span', {
    staticClass: "pl-3",
    staticStyle: {
      "font-weight": "900"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "font-weight": "900",
      "font-size": "15px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleComments.apply(null, arguments)
      }
    }
  }, [_vm._v("Comments (" + _vm._s(_vm.comments.length || 0) + ")")]), _vm._v(" "), _c('span', [_vm._v("·")]), _vm._v(" Likes (" + _vm._s(_vm.likes.length) + ")")])]), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-0 px-2"
  })], 1)], 1), _vm._v(" "), (_vm.comments.length > 0) ? _c('v-list', {
    class: {
      'hidden': !_vm.showComments
    },
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, _vm._l((_vm.comments), function(comment) {
    return _c('v-list-tile', {
      key: comment.commentId,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-menu', {
      attrs: {
        "max-width": "300",
        "min-width": "250",
        "z-index": "1",
        "bottom": "",
        "nudge-bottom": 30,
        "nudge-top": -20,
        "nudge-left": 10
      }
    }, [_c('v-list-tile-avatar', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('img', {
      attrs: {
        "alt": comment && comment.user.avatar ? comment.user.avatar : 'default-avatar.gif',
        "src": comment && comment.user.avatar ? comment.user.avatar : __webpack_require__(1065)
      }
    })]), _vm._v(" "), _c('avatar-popup', {
      attrs: {
        "item": comment,
        "uid": comment.user.uid
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      staticStyle: {
        "font-size": "15px",
        "font-weight": "900",
        "text-transform": "capitalize",
        "margin-top": "-17px"
      },
      style: ({
        color: _vm.styles.general.theme_color_dark
      })
    }, [_vm._v(_vm._s(comment.user.firstname + ' ' + comment.user.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(comment.comment))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_vm._v(_vm._s(_vm._f("fromNow")(comment.date)))])])], 1)
  }), 1) : _vm._e(), _vm._v(" "), (_vm.comments.length > 0) ? _c('v-divider', {
    class: {
      'hidden': !_vm.showComments
    }
  }) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md9": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mt-0",
    staticStyle: {
      "padding-bottom": "0px",
      "height": "100%"
    },
    attrs: {
      "full-width": "",
      "single-line": "",
      "label": "Leave a comment"
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": "",
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "text-xs-center pt-2",
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "font-weight": "900",
      "font-size": "22px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "round": "",
      "flat": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.postComment(_vm.itemKey)
      }
    }
  }, [_vm._v("Post")])], 1)])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "490"
    },
    model: {
      value: (_vm.allowPin),
      callback: function($$v) {
        _vm.allowPin = $$v
      },
      expression: "allowPin"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Pin this Post to the top of the activity feed")]), _vm._v(" "), _c('v-card-text', [_vm._v("This will replace any previously pinned post. Are you sure?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.allowPin = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "secondary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.pinPost();
        _vm.allowPin = false
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1319),
  /* template */
  __webpack_require__(1696),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CreateActivityComponent_vue__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CreateActivityComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CreateActivityComponent_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grouppage_events_vue__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__grouppage_events_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__grouppage_events_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grouppage_notifications_vue__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__grouppage_notifications_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__grouppage_notifications_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__grouppage_top5_Top5_vue__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__grouppage_top5_Top5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__grouppage_top5_Top5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Timeline_vue__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Timeline_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Timeline_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__grouppage_settings_vue__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__grouppage_settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__grouppage_settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__grouppage_events_Top5Events_vue__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__grouppage_events_Top5Events_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__grouppage_events_Top5Events_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__grouppage_inviteUser_vue__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__grouppage_inviteUser_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__grouppage_inviteUser_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__grouppage_members_vue__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__grouppage_members_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__grouppage_members_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_chat_sideboxChat_vue__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_chat_sideboxChat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_chat_sideboxChat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__grouppage_UserInfo_vue__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__grouppage_UserInfo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__grouppage_UserInfo_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var db = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    NewActivity: __WEBPACK_IMPORTED_MODULE_1__components_CreateActivityComponent_vue___default.a,
    Top5: __WEBPACK_IMPORTED_MODULE_4__grouppage_top5_Top5_vue___default.a,
    Notifications: __WEBPACK_IMPORTED_MODULE_3__grouppage_notifications_vue___default.a,
    Settings: __WEBPACK_IMPORTED_MODULE_6__grouppage_settings_vue___default.a,
    EventsTab: __WEBPACK_IMPORTED_MODULE_2__grouppage_events_vue___default.a,
    InviteUser: __WEBPACK_IMPORTED_MODULE_8__grouppage_inviteUser_vue___default.a,
    Members: __WEBPACK_IMPORTED_MODULE_9__grouppage_members_vue___default.a,
    Timeline: __WEBPACK_IMPORTED_MODULE_5__components_Timeline_vue___default.a,
    SideViewChat: __WEBPACK_IMPORTED_MODULE_10__components_chat_sideboxChat_vue___default.a,
    TopEvents: __WEBPACK_IMPORTED_MODULE_7__grouppage_events_Top5Events_vue___default.a,
    UserInfo: __WEBPACK_IMPORTED_MODULE_11__grouppage_UserInfo_vue___default.a
  },
  data: function data() {
    return {
      groupPageTab: 'tab-1',
      firstFiveMembers: [],
      dialog: true,
      count: 0,
      items: [],
      tempImgUrl: null,
      tempFile: null,
      feed: [],
      counter: 10,
      disableCoverPhotoSaveButton: false,
      modify: {
        reposition: {
          hide: false,
          save: false
        },
        changePhoto: {
          hide: false,
          save: false
        },
        groupTitle: false
      },
      type: 'groupposts',
      groupUsers: []
    };
  },
  firebase: function firebase() {
    return {
      getGroup: db.ref('groups').orderByKey().equalTo("-".concat(this.$route.params.id)),
      groupPosts: db.ref('groupposts').child("/-".concat(this.$route.params.id)),
      groupMembers: db.ref('groups').child("-".concat(this.$route.params.id, "/members"))
    };
  },
  created: function created() {
    this.getGroup;
  },
  mounted: function mounted() {
    this.getPostsWithUser;
    this.getMembers;
  },
  computed: {
    privileges: function privileges() {
      return this.$store.getters.getUserPrivileges;
    },
    group: function group() {
      return this.getGroup[0];
    },
    groupId: function groupId() {
      return this.getGroup[0].groupId;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    strippedGroupId: function strippedGroupId() {
      return this.group.groupId.replace('-', '');
    },
    groupName: function groupName() {
      return this.group.name;
    },
    coverPhoto: function coverPhoto() {
      return this.group.coverPhoto.url;
    },
    coverBackgroundPosition: function coverBackgroundPosition() {
      return this.group.coverPhoto.backgroundPosition;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    setGroupPostData: function setGroupPostData() {
      return {
        groupId: this.groupId
      };
    },
    extraUrl: function extraUrl() {
      return "/".concat(this.getGroup[0].groupId);
    },
    getPostsWithUser: function getPostsWithUser() {
      var self = this;
      return this.$firebaseRefs.groupPosts.orderByChild("approvalStatus").equalTo(1).limitToLast(this.counter).on('value', function (result) {
        if (result.val()) {
          var results = result.val();
          var postKeys = Object.keys(results);

          var userIds = self._.uniq(postKeys.map(function (post) {
            return results[post].uid;
          }));

          var userInfo = userIds.map(function (id) {
            return self.$firebase.database().ref('users/' + id).once('value');
          });
          Promise.all(userInfo).then(function (users) {
            self.items = [];
            self.feeds = [];
            users.forEach(function (user) {
              postKeys.forEach(function (post) {
                if (results[post].uid === user.val().uid) {
                  var item = results[post];
                  self.$firebase.database().ref('companies/' + user.val().cid).once('value').then(function (company) {
                    item.company = {};
                    Object.assign(item.company, company.val());
                    item.postKey = post;
                    item.avatar = user.val().avatar;
                    item.user = {};
                    Object.assign(item.user, user.val());
                    self.items.push(item);
                    self.feed = self.items.sort(function (d1, d2) {
                      return new Date(d2.posteddate).getTime() - new Date(d1.posteddate).getTime();
                    });
                  });
                }
              });
            });
          });
        } else {
          self.feed = [];
        }
      });
    },
    getMembers: function getMembers() {
      var self = this;
      return this.$firebaseRefs.groupMembers.orderByChild("approvalStatus").equalTo(1).on('value', function (result) {
        if (result.val()) {
          var results = result.val();
          var membersKeys = Object.keys(results);
          var userInfo = membersKeys.map(function (id) {
            return self.$firebase.database().ref('users/' + id).once('value');
          });
          Promise.all(userInfo).then(function (users) {
            self.groupUsers = [];
            self.firstMembers = [];
            users.forEach(function (user) {
              self.groupUsers.push(user.val());
            });
            self.firstFiveMembers = self.groupUsers.slice(0, 5);
          });
        } else {
          self.firstFiveMembers = [];
        }
      });
    }
  },
  methods: {
    pickFile: function pickFile() {
      this.$refs.imgupload.click();
    },
    getUserInfo: function getUserInfo(uid, index) {
      return this.$firebase.database().ref('users/' + uid).once('value');
    },
    getCompanyInformation: function getCompanyInformation(cid, index) {
      return this.$firebase.database().ref('companies/' + cid).once('value');
    },
    counterPost: function counterPost() {
      var self = this;
      self.counter = self.counter + 10;
      self.items = [];
      self.count = 0;
      self.feed = [];
      this.getGroupPosts(this.counter);
    },
    getGroupPosts: function getGroupPosts(counter) {
      var self = this;
      this.$firebase.database().ref().child("groupposts/".concat(this.groupId)).orderByChild("approvalStatus").equalTo(1).limitToLast(counter).once('value', function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          var childKey = childSnapshot.key;
          var childData = childSnapshot.val();
          self.getUserInfo(childData.uid, self.count).then(function (result) {
            childData.user = result.val();
            childData.avatar = childData.user.avatar;
          }).then(function () {
            if (childData.user.cid) {
              return self.getCompanyInformation(childData.user.cid, self.count);
            }
          }).then(function (value) {
            if (value) {
              childData.company = value.val();
            }
          }).then(function () {
            self.items.push(childData);
            self.items[self.count]['postKey'] = childKey;
            self.count += 1;
            self.feed = self.items.sort(function (d1, d2) {
              return new Date(d2.posteddate).getTime() - new Date(d1.posteddate).getTime();
            });
          });
        });
      });
    },
    setTemp: function setTemp() {
      var self = this;
      var reader = new window.FileReader();
      var blob = this.$refs.imgupload.files[0];
      this.tempFile = blob;

      reader.onload = function (e) {
        self.tempImgUrl = reader.result;
      };

      reader.readAsDataURL(blob);
    },
    saveCoverPhoto: function saveCoverPhoto() {
      var self = this;
      var storageRef = this.$firebase.storage().ref("group/".concat(this.groupId, "/coverPhoto.jpg"));
      this.disableCoverPhotoSaveButton = true;
      storageRef.put(this.tempFile).then(function (res) {
        if (res.state === 'success') {
          self.$firebase.database().ref("groups/".concat(self.groupId, "/coverPhoto/url")).set(res.downloadURL);
          self.disableCoverPhotoSaveButton = false;
          self.modify = {
            reposition: {
              hide: false,
              save: false
            },
            changePhoto: {
              hide: false,
              save: false
            },
            groupTitle: false
          };
        }
      });
    },
    savePosition: function savePosition() {
      this.$firebase.database().ref("groups/".concat(this.groupId, "/coverPhoto/backgroundPosition")).set(this.coverBackgroundPosition);
      window.$('#group-cover-photo').backgroundDraggable('disable');
      this.modify = {
        reposition: {
          hide: false,
          save: false
        },
        changePhoto: {
          hide: false,
          save: false
        },
        groupTitle: false
      };
    },
    handleModify: function handleModify(modifier) {
      if (modifier === 'reposition') {
        var self = this;
        window.$('#group-cover-photo').backgroundDraggable({
          done: function done() {
            var backgroundPosition = window.$('#group-cover-photo').css('background-position');
            self.coverBackgroundPosition.x = backgroundPosition.split(' ')[0];
            self.coverBackgroundPosition.y = backgroundPosition.split(' ')[1];
          }
        });
        this.modify = {
          reposition: {
            hide: false,
            save: true
          },
          changePhoto: {
            hide: true,
            save: false
          },
          groupTitle: true
        };
      } else if (modifier === 'changePhoto') {
        this.modify = {
          reposition: {
            hide: true,
            save: false
          },
          changePhoto: {
            hide: false,
            save: true
          },
          groupTitle: true
        };
        this.pickFile();
      } else if (modifier === 'groupTitle') {
        this.modify = {
          reposition: {
            hide: true,
            save: false
          },
          changePhoto: {
            hide: false,
            save: false
          },
          groupTitle: false
        };
      }
    }
  }
};

/***/ }),

/***/ 1317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      width: 360
    };
  },
  methods: {
    onResize: function onResize() {
      if (window.innerWidth > 1300) {
        this.width = 260;
      }

      if (window.innerWidth > 1900) {
        this.width = 420;
      }
    }
  },
  computed: {
    company: function company() {
      return this.$store.getters.getCompanyDetails;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    items: function items() {
      // if (this.company.companylegalname === '') {
      //   return [
      //     {
      //       title: `${this.user.firstname} ${this.user.lastname}`,
      //       icon: 'person'
      //     }
      //   ]
      // }
      return [{
        title: this.user.companylegalname,
        icon: 'store'
      }, {
        title: this.user.jobtitle,
        icon: 'assignment_ind'
      }, {
        title: this.user.department,
        icon: 'work'
      }];
    }
  }
};

/***/ }),

/***/ 1318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_fullcalendar__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_fullcalendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_fullcalendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_NewEventsModal_vue__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events_NewEventsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__events_NewEventsModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_EventViewModal_vue__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_EventViewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__events_EventViewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_EventTimelineComponent_vue__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_EventTimelineComponent_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__events_EventTimelineComponent_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var db = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['groupId'],
  data: function data() {
    return {
      dialog: false,
      trigger: false,
      eventModal: false,
      events: [],
      items: [],
      count: 0,
      eventData: '',
      activeTab: null,
      counter: 10
    };
  },
  components: {
    FullCalendar: __WEBPACK_IMPORTED_MODULE_2_vue_fullcalendar___default.a,
    NewEventsModal: __WEBPACK_IMPORTED_MODULE_3__events_NewEventsModal_vue___default.a,
    EventViewModal: __WEBPACK_IMPORTED_MODULE_4__events_EventViewModal_vue___default.a,
    EventTimeline: __WEBPACK_IMPORTED_MODULE_5__events_EventTimelineComponent_vue___default.a
  },
  firebase: function firebase() {
    return {
      getEvents: db.ref('groupevents').child("/".concat(this.groupId))
    };
  },
  computed: {
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    strippedGroupId: function strippedGroupId() {
      return this.groupId.replace('-', '');
    },
    groupRoute: function groupRoute() {
      return "/".concat(this.strippedGroupId);
    },
    getGroupEventsWithUser: function getGroupEventsWithUser() {
      var self = this;
      return this.$firebaseRefs.getEvents.orderByChild('approvalStatus').equalTo(1).limitToLast(this.counter).on('value', function (result) {
        if (result.val()) {
          self.items = [];
          self.feed = [];
          var results = result.val();
          var eventKeys = Object.keys(results);

          var userIds = self._.uniq(eventKeys.map(function (event) {
            return results[event].uid;
          }));

          var userInfo = userIds.map(function (id) {
            return self.$firebase.database().ref('users/' + id).once('value');
          });
          Promise.all(userInfo).then(function (users) {
            users.forEach(function (user) {
              eventKeys.forEach(function (event) {
                if (results[event].uid === user.val().uid) {
                  var item = results[event];
                  item.eventKey = event['.key'];
                  item.avatar = user.val().avatar;
                  item.user = {};
                  Object.assign(item.user, user.val());
                  var eventTime = new Date(item.eventdate).getTime();
                  var beginningOfDay = __WEBPACK_IMPORTED_MODULE_0_moment__().startOf('day').format('x');

                  if (eventTime >= beginningOfDay) {
                    self.items.push(item);
                  }

                  self.events = self.items.sort(function (d1, d2) {
                    return new Date(d2.posteddate).getTime() - new Date(d1.posteddate).getTime();
                  });
                }
              });
            });
          });
        } else {
          self.events = [];
        }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    var calendarCSS = "\n      .full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item {\n        color: #fff;\n        background-color: ".concat(this.styles.general.theme_color_light, ";\n      }\n      .week {\n        color: ").concat(this.styles.general.theme_color_light, "\n      }\n      .header-center .title, .header-center .prev-month, .header-center .next-month {\n        color: ").concat(this.styles.general.theme_color_light, ";\n      float:left;\n      \n      \n    }");
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = calendarCSS;
    document.getElementsByTagName('head')[0].appendChild(style);
    var self = this;
    this.$on('togglemodal', function (val) {
      _this.dialog = val;
    });
    this.$on('closeModal', function () {
      self.openEventModal = false;
      self.openUpdateEventModal = false;
      self.openCalendarModal = false;
    });
    this.getGroupEventsWithUser;
  },
  methods: {
    close: function close() {
      this.dialog = false;
      this.$emit('togglemodal', false);
    },
    closeModal: function closeModal() {
      this.dialog = false;
    },
    viewEvent: function viewEvent(val) {
      this.eventData = val;
      this.eventModal = true;
    },
    eventClick: function eventClick(event, jsEvent, pos) {
      this.viewEvent(event);
    },
    openModal: function openModal() {
      this.dialog = true;
    },
    closeViewEvent: function closeViewEvent() {
      this.eventModal = false;
    },
    fetchGroupEvents: function fetchGroupEvents(counter) {
      var self = this;
      this.$firebase.database().ref("groupevents/".concat(this.groupId)).orderByChild('approvalStatus').equalTo(1).limitToFirst(this.counter).on('value', function (snap) {
        self.items = [];
        self.events = [];
        snap.forEach(function (childSnapshot) {
          var childData = childSnapshot.val();
          self.getUserInfo(childData.uid, self.count).then(function (result) {
            childData.user = result.val();
            childData.avatar = childData.user.avatar;
            self.items.push(childData);
          });
        });
        self.events = self.items.sort(function (d1, d2) {
          return new Date(d2.submitdata).getTime() - new Date(d1.submitdate).getTime();
        });
      });
    },
    getUserInfo: function getUserInfo(uid, index) {
      return this.$firebase.database().ref('users/' + uid).once('value');
    },
    getCompanyInformation: function getCompanyInformation(cid, index) {
      return this.$firebase.database().ref('companies/' + cid).once('value');
    }
  }
};

/***/ }),

/***/ 1319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mdi_css_materialdesignicons_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mdi_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mdi_css_materialdesignicons_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      datepickermenu: false,
      timepickermenu: false,
      endtimepickermenu: false,
      alert: false,
      event: {
        submitdate: null,
        uid: this.$store.getters.getUserDetails.uid,
        title: '',
        starteventtime: null,
        endeventtime: null,
        eventdate: null,
        location: '',
        description: '',
        link: '',
        attatchment1: '',
        attatchment2: '',
        approvalStatus: 0,
        approvaldate: ''
      }
    };
  },
  props: ['trigger', 'groupRoute', 'groupId', 'type'],
  mounted: function mounted() {
    this.alert = false;
  },
  methods: {
    closeModal: function closeModal() {
      this.alert = false;
      this.$emit('closeModal', 'openEventModal');
    },
    save: function save() {
      var event = this.event;

      if (this.type === 'groupevents') {
        event.groupId = "-".concat(this.groupId);
      }

      event.submitdate = Date.now();
      this.$firebase.database().ref("".concat(this.type, "/").concat(this.groupId)).push().set(event);
      var snackbar = {
        active: true,
        text: 'Event was created successfully, but needs to be approve by the admin'
      };
      this.alert = true;
      this.$store.dispatch('triggerSnackbar', snackbar);
      this.event.title = '';
      this.event.starteventtime = '';
      this.event.endeventtime = '';
      this.event.eventdate = '';
      this.event.location = '';
      this.event.description = '';
      this.event.link = '';
    }
  },
  computed: {
    dialog: function dialog() {
      return this.trigger;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    buttonColor: function buttonColor() {
      return this.styles.general.theme_color_dark;
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    }
  }
};

/***/ }),

/***/ 1320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mdi_css_materialdesignicons_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mdi_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mdi_css_materialdesignicons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewEventsModal_vue__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewEventsModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__NewEventsModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UpdateEventsModel_vue__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UpdateEventsModel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UpdateEventsModel_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_calendarModal_vue__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_modal_calendarModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_modal_calendarModal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var db = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['groupId', 'add'],
  components: {
    NewEventModal: __WEBPACK_IMPORTED_MODULE_3__NewEventsModal_vue___default.a,
    CalendarModal: __WEBPACK_IMPORTED_MODULE_5__components_modal_calendarModal_vue___default.a,
    UpdateEventModal: __WEBPACK_IMPORTED_MODULE_4__UpdateEventsModel_vue___default.a
  },
  data: function data() {
    return {
      openCalendarModal: false,
      openEventModal: false,
      openUpdateEventModal: false,
      items: [],
      events: [],
      count: 0,
      selectedItem: {}
    };
  },
  firebase: function firebase() {
    return {
      getTopEvents: db.ref('groupevents').child("/".concat(this.groupId))
    };
  },
  methods: {
    close: function close() {
      this.$emit('togglemodal', false);
      this.openEventModal = false;
    },
    openUpdateModal: function openUpdateModal(item) {
      this.openEventModal = false;
      this.openUpdateEventModal = true;
      this.selectedItem = item;
    },
    openNewModal: function openNewModal() {
      this.openEventModal = true;
    },
    closeModal: function closeModal(modal) {
      var self = this;
      self[modal] = false;
    },
    openCalendar: function openCalendar() {
      this.openCalendarModal = true;
    }
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    fetchTopFiveEvents: function fetchTopFiveEvents() {
      var self = this;
      return this.$firebaseRefs.getTopEvents.orderByChild('approvalStatus').equalTo(1).limitToLast(5).on('value', function (snap) {
        if (snap.val()) {
          var results = snap.val();
          var eventKeys = Object.keys(results);

          var userIds = self._.uniq(eventKeys.map(function (event) {
            return results[event].uid;
          }));

          var userInfo = userIds.map(function (id) {
            return self.$firebase.database().ref('users/' + id).once('value');
          });
          self.items = [];
          self.events = [];
          Promise.all(userInfo).then(function (users) {
            users.forEach(function (user) {
              eventKeys.forEach(function (event) {
                if (results[event].uid === user.val().uid) {
                  var item = results[event];
                  item.eventKey = event;
                  item.avatar = user.val().avatar;
                  item.user = {};
                  Object.assign(item.user, user.val());
                  var eventTime = new Date(item.eventdate).getTime();
                  var beginningOfDay = __WEBPACK_IMPORTED_MODULE_0_moment__().startOf('day').format('x');

                  if (eventTime >= beginningOfDay) {
                    self.items.push(item);
                  }

                  self.events = self.items.sort(function (d1, d2) {
                    return new Date(d2.eventdate).getTime() < new Date(d1.eventdate).getTime();
                  });
                }
              });
            });
          });
        } else {
          self.events = [];
        }
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    var self = this;
    this.$on('togglemodal', function (val) {
      _this.dialog = val;
    });
    this.fetchTopFiveEvents;
  }
};

/***/ }),

/***/ 1321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mdi_css_materialdesignicons_min_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mdi_css_materialdesignicons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mdi_css_materialdesignicons_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      openModal: this.$props.dialog1,
      datepickermenu: false,
      timepickermenu: false,
      endtimepickermenu: false,
      event: {
        submitdate: null,
        user: this.$store.getters.getUserDetails,
        title: '',
        starteventtime: null,
        endeventtime: null,
        eventdate: null,
        location: '',
        description: '',
        link: '',
        attatchment1: '',
        attatchment2: '',
        approvalStatus: 0,
        approvaldate: ''
      },
      showAlert: false
    };
  },
  props: ['trigger', 'item', 'groupId'],
  methods: {
    save: function save() {
      var _this = this;

      this.$firebase.database().ref("groupevents/".concat(this.groupId, "/").concat(this.item.eventKey)).update({
        'title': this.item.title
      }).then(function () {
        _this.showAlert = true;
      });
    },
    closeModal: function closeModal() {
      this.showAlert = false;
      this.$emit('closeModal', 'openUpdateEventModal');
    }
  },
  mounted: function mounted() {
    this.showAlert = false;
  },
  computed: {
    dialog: function dialog() {
      return this.trigger;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    }
  }
};

/***/ }),

/***/ 1322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['groupId', 'group'],
  data: function data() {
    return {
      email: ''
    };
  },
  methods: {
    inviteUser: function inviteUser() {
      var _this = this;

      var groupId = "-".concat(this.groupId);
      var email = this.email;
      var self = this;

      if (email.length) {
        this.$firebase.database().ref("users").once('value').then(function (snap) {
          snap.forEach(function (user) {
            user = user.val();

            if (user.email === email) {
              if (self.group.privacy.value === 2) {
                user.approvalStatus = 0;
              } else {
                user.approvalStatus = 1;
              }

              _this.email = '';

              _this.$firebase.database().ref("groups/".concat(groupId, "/members/").concat(user.uid)).set(user);

              return true;
            }
          });
        });
      }
    }
  }
};

/***/ }),

/***/ 1323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var db = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['groupId', 'group'],
  data: function data() {
    return {
      totalItems: 0,
      search: '',
      loading: false,
      members: [],
      headers: [{
        text: 'Full Name',
        align: 'center',
        value: 'firstname',
        sortable: false
      }, {
        text: 'Company',
        align: 'center',
        value: 'companylegalname',
        sortable: false
      }, {
        text: 'Email',
        align: 'center',
        value: 'email',
        sortable: false
      }, {
        text: 'Actions',
        align: 'left',
        value: 'actions',
        sortable: false
      }],
      memberItems: [],
      counter: 10
    };
  },
  firebase: function firebase() {
    return {
      groupMembers: db.ref('groups').child("/-".concat(this.groupId, "/members")).orderByChild('approvalStatus').equalTo(1).limitToFirst(this.counter)
    };
  },
  methods: {
    remove: function remove(user) {
      this.$firebase.database().ref("groups/-".concat(this.groupId, "/members/").concat(user.uid)).set({});
    }
  },
  mounted: function mounted() {
    this.getGroupMembers;
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    getGroupMembers: function getGroupMembers() {
      var self = this;
      return this.$firebaseRefs.groupMembers.orderByChild('approvalStatus').equalTo(1).limitToFirst(this.counter).on('value', function (result) {
        if (result.val()) {
          var results = result.val();
          var approvedMembersKey = Object.keys(results);

          var userIds = self._.uniq(approvedMembersKey.map(function (member) {
            return results[member].uid;
          }));

          var userInfo = userIds.map(function (id) {
            return self.$firebase.database().ref('users/' + id).once('value');
          });
          self.members = [];
          self.memberItems = [];
          Promise.all(userInfo).then(function (users) {
            users.forEach(function (user) {
              approvedMembersKey.forEach(function (member) {
                if (results[member].uid === user.val().uid) {
                  var item = results[member];
                  self.$firebase.database().ref('companies/' + user.val().cid).once('value').then(function (company) {
                    item.companylegalname = company.val().companylegalname;
                    item.avatar = user.val().avatar;
                    item.firstname = user.val().firstname;
                    item.lastname = user.val().lastname;
                    item.email = user.val().email;
                    self.memberItems.push(item);
                    self.members = self.memberItems.sort(function (d1, d2) {
                      return new Date(d2.dateAdded).getTime() - new Date(d1.dateAdded).getTime();
                    });
                  });
                }
              });
            });
          });
        } else {
          self.members = [];
        }
      });
    }
  }
};

/***/ }),

/***/ 1324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var db = __WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.$firebase.database();
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      counter: 10,
      notificationItems: [],
      notifications: []
    };
  },
  props: ['groupId'],
  firebase: function firebase() {
    return {
      groupMembers: db.ref('groups').child("/-".concat(this.groupId, "/members"))
    };
  },
  mounted: function mounted() {
    this.getUnApprovedGroupMembers;
  },
  computed: {
    getUnApprovedGroupMembers: function getUnApprovedGroupMembers() {
      var self = this;
      return this.$firebaseRefs.groupMembers.orderByChild('approvalStatus').equalTo(0).limitToFirst(this.counter).on('value', function (result) {
        if (result.val()) {
          var results = result.val();
          var unapprovedKeys = Object.keys(results);

          var userIds = self._.uniq(unapprovedKeys.map(function (member) {
            return results[member].uid;
          }));

          var userInfo = userIds.map(function (id) {
            return self.$firebase.database().ref('users/' + id).once('value');
          });
          self.notifications = [];
          self.notificationItems = [];
          Promise.all(userInfo).then(function (users) {
            users.forEach(function (user) {
              unapprovedKeys.forEach(function (member) {
                if (results[member].uid === user.val().uid) {
                  var item = results[member];
                  self.$firebase.database().ref('companies/' + user.val().cid).once('value').then(function (company) {
                    item.companylegalname = company.val().companylegalname;
                    item.avatar = user.val().avatar;
                    item.firstname = user.val().firstname;
                    item.lastname = user.val().lastname;
                    item.email = user.val().email;
                    item.jobtitle = user.val().jobtitle;
                    self.notificationItems.push(item);
                    self.notifications = self.notificationItems.sort(function (d1, d2) {
                      return new Date(d2.dateAdded).getTime() - new Date(d1.dateAdded).getTime();
                    });
                  });
                }
              });
            });
          });
        } else {
          self.feed = [];
        }
      });
    }
  },
  methods: {
    accept: function accept(user) {
      user.approvalStatus = 1;
      this.$firebase.database().ref("groups/-".concat(this.groupId, "/members/").concat(user.uid)).set(user);
    },
    deny: function deny(user) {
      this.$firebase.database().ref("groups/-".concat(this.groupId, "/members/").concat(user.uid)).set({});
    }
  }
};

/***/ }),

/***/ 1325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['group', 'groupId'],
  data: function data() {
    return {
      dialog: false
    };
  },
  methods: {
    updateGroup: function updateGroup() {
      var group = this.group;
      this.$firebase.database().ref("groups/-".concat(this.groupId, "/name")).set(group.name);
      this.$firebase.database().ref("groups/-".concat(this.groupId, "/privacy")).set(group.privacy);
      this.$firebase.database().ref("groups/-".concat(this.groupId, "/description")).set(group.description);
      var snackbar = {
        active: true,
        text: 'Group details updated successfully'
      };
      this.$store.dispatch('triggerSnackbar', snackbar);
    },
    deleteGroup: function deleteGroup() {
      this.$firebase.database().ref("groups/-".concat(this.groupId)).set({});
      this.$router.replace('/groups');
    }
  }
};

/***/ }),

/***/ 1326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modal_info_opportunitiesViewModal_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_modal_info_opportunitiesViewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_modal_info_opportunitiesViewModal_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    opportunitiesModal: __WEBPACK_IMPORTED_MODULE_0__components_modal_info_opportunitiesViewModal_vue___default.a
  },
  data: function data() {
    return {
      openDialog: false,
      selectedItem: {}
    };
  },
  methods: {
    openModal: function openModal(item) {
      this.openDialog = true;
      this.selectedItem = item;
    }
  },
  computed: {
    items: function items() {
      var data = this.$store.getters.getOpportunitiesState.filter(function (item) {
        if (item.noticetype.match('Cancelled') || item.noticetype.match('Award') || item.noticetype.match('Cancellation') || item.noticetype.match('Award Notice')) {
          return null;
        }

        return item;
      });
      return data.slice(0, 6);
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$on('cancel', function () {
      _this.openDialog = false;
    });
    this.$store.dispatch('getOpportunities');
  }
};

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".reduce-fab{width:40px!important;height:40px!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/grouppage/members.vue"],"names":[],"mappings":"AACA,YACI,qBAAuB,AACvB,qBAAwB,CAC3B","file":"members.vue","sourcesContent":["\n.reduce-fab {\n    width: 40px !important;\n    height: 40px !important;\n} \n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1387:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".info-bg{background:#3f9cf9;height:80px}.info-profile-img img{width:100px;height:100px;top:20px;border-radius:100%;border:2px solid #0288d1;position:absolute;margin-left:auto;margin-right:auto}.info-list{list-style:none}.info-list li{margin-bottom:10px;display:-webkit-box;display:-ms-flexbox;display:flex}.info-list li div{color:#929292;font-size:13px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/grouppage/UserInfo.vue"],"names":[],"mappings":"AACA,SACE,mBAAoB,AACpB,WAAa,CACd,AACD,sBACE,YAAa,AACb,aAAc,AACd,SAAU,AACV,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,iBAAkB,AAClB,iBAAmB,CACpB,AACD,WACE,eAAiB,CAClB,AACD,cACE,mBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,kBACE,cAAe,AACf,cAAgB,CACjB","file":"UserInfo.vue","sourcesContent":["\n.info-bg {\n  background: #3f9cf9;\n  height: 80px;\n}\n.info-profile-img img {\n  width: 100px;\n  height: 100px;\n  top: 20px;\n  border-radius: 100%;\n  border: 2px solid #0288d1;\n  position: absolute;\n  margin-left: auto;\n  margin-right: auto;\n}\n.info-list {\n  list-style: none;\n}\n.info-list li {\n  margin-bottom: 10px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.info-list li div {\n  color: #929292;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1404:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"notifications.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1415:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".tabItem{text-transform:capitalize;color:#000;font-size:19px;font-weight:500;margin-left:-20px;overflow-y:hidden}.change-photo,.position-photo{padding-top:15px;width:auto;float:right}#group-cover-photo .btn{padding:8px;background:hsla(0,0%,100%,.22);border:1px solid #fff;color:#fff;cursor:pointer}#group-cover-photo,#group-cover-photo .btn:hover{background:hsla(0,0%,100%,.55)}#group-cover-photo{-webkit-filter:grayscale()(60%);filter:grayscale(65%)}.load-more{padding:7px}.group-title,.load-data-div{text-align:center}.group-title{padding-top:80px}.tab-white-transparent{background:#ebebeb;background:-webkit-gradient(linear,left top,left bottom,from(#ebebeb),color-stop(50%,#e6e6e6),color-stop(51%,#dfdfdf),to(#fefefe));background:linear-gradient(180deg,#ebebeb 0,#e6e6e6 50%,#dfdfdf 51%,#fefefe);filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#ebebeb\",endColorstr=\"#fefefe\",GradientType=0)}.tabs__wrapper{overflow:hidden!important;overflow-y:hidden}.text-outline{color:#fff;text-shadow:#000 0 0 1px,#000 0 0 1px,#000 0 0 1px,#000 0 0 1px,#000 0 0 1px,#000 0 0 1px;-webkit-font-smoothing:antialiased}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/groupPageView.vue"],"names":[],"mappings":"AACA,SACG,0BAA0B,WAAW,eAAe,gBAAgB,kBAAkB,iBAAmB,CAC3G,AAMD,8BACI,iBAAkB,AAClB,WAAY,AACZ,WAAa,CAChB,AACD,wBACI,YAAa,AACb,+BAAsC,AACtC,sBAAuB,AACvB,WAAY,AACZ,cAAgB,CACnB,AAID,iDAFI,8BAAsC,CAMzC,AAJD,mBAEI,gCAAiC,AACjC,qBAAuB,CAC1B,AACD,WACA,WAAY,CACX,AAID,4BAFA,iBAAkB,CAQjB,AAND,aACI,gBAAkB,CAKrB,AACD,uBACI,mBAA6B,AAC7B,mIAAyL,AACzL,6EAAwI,AACxI,+GAAoH,CACvH,AACD,eACI,0BAA4B,AAC5B,iBAAmB,CACtB,AACD,cACI,WAAY,AACZ,0FACkE,AAClE,kCAAoC,CACvC","file":"groupPageView.vue","sourcesContent":["\n.tabItem\n  {text-transform:capitalize;color:#000;font-size:19px;font-weight:500;margin-left:-20px;overflow-y: hidden;\n}\n.change-photo {\n    padding-top: 15px;\n    width: auto;\n    float: right;\n}\n.position-photo {\n    padding-top: 15px;\n    width: auto;\n    float: right;\n}\n#group-cover-photo .btn {\n    padding: 8px;\n    background: rgba(255, 255, 255, 0.22);\n    border: 1px solid #fff;\n    color: #fff;\n    cursor: pointer;\n}\n#group-cover-photo .btn:hover {\n    background: rgba(255, 255, 255, 0.55);\n}\n#group-cover-photo  {\n    background: rgba(255, 255, 255, 0.55);\n    -webkit-filter: grayscale()(60%); /* Safari 6.0 - 9.0 */\n    filter: grayscale(65%);\n}\n.load-more{\npadding:7px;\n}\n.load-data-div{\ntext-align:center;\n}\n.group-title {\n    padding-top: 80px;\n    /* width: 500px; */\n    text-align: center;\n    /* margin-left: auto;\n    margin-right: auto; */\n}\n.tab-white-transparent {\n    background: rgb(235,235,235); /* FF3.6-15 */ /* Chrome10-25,Safari5.1-6 */\n    background: -webkit-gradient(linear, left top, left bottom, from(rgba(235,235,235,1)),color-stop(50%, rgba(230,230,230,1)),color-stop(51%, rgba(223,223,223,1)),to(rgba(254,254,254,1)));\n    background: linear-gradient(to bottom, rgba(235,235,235,1) 0%,rgba(230,230,230,1) 50%,rgba(223,223,223,1) 51%,rgba(254,254,254,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ebebeb', endColorstr='#fefefe',GradientType=0 );\n}\n.tabs__wrapper {\n    overflow: hidden !important;\n    overflow-y: hidden;\n}\n.text-outline {\n    color: #fff;\n    text-shadow: #000 0px 0px 1px, #000 0px 0px 1px, #000 0px 0px 1px,\n                 #000 0px 0px 1px, #000 0px 0px 1px, #000 0px 0px 1px;\n    -webkit-font-smoothing: antialiased;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1427:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".text-field{width:100%;padding-left:10px;border:1px solid #ccc;height:40px}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/grouppage/inviteUser.vue"],"names":[],"mappings":"AACA,YACE,WAAY,AACZ,kBAAmB,AACnB,sBAAuB,AACvB,WAAa,CACd","file":"inviteUser.vue","sourcesContent":["\n.text-field {\n  width: 100%;\n  padding-left: 10px;\n  border: 1px solid #ccc;\n  height: 40px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1428:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"settings.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".comp-full-calendar{max-width:none!important;padding:0!important}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/grouppage/events.vue"],"names":[],"mappings":"AACA,oBACI,yBAA2B,AAC3B,mBAAuB,CAC1B","file":"events.vue","sourcesContent":["\n.comp-full-calendar {\n    max-width: none !important;\n    padding: 0px !important\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1475:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1386);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("413f9882", content, true, {});

/***/ }),

/***/ 1476:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1387);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("fa87664c", content, true, {});

/***/ }),

/***/ 1493:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1404);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("1676e957", content, true, {});

/***/ }),

/***/ 1504:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1415);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("1a2db2c6", content, true, {});

/***/ }),

/***/ 1516:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1427);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("bbe57b98", content, true, {});

/***/ }),

/***/ 1517:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("05eda08e", content, true, {});

/***/ }),

/***/ 1518:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1429);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("9577b09c", content, true, {});

/***/ }),

/***/ 1616:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1476)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1317),
  /* template */
  __webpack_require__(1681),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1617:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1518)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1318),
  /* template */
  __webpack_require__(1734),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1618:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1320),
  /* template */
  __webpack_require__(1732),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1619:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1321),
  /* template */
  __webpack_require__(1736),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1620:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1516)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1322),
  /* template */
  __webpack_require__(1731),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1621:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1475)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1323),
  /* template */
  __webpack_require__(1680),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1622:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1493)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1324),
  /* template */
  __webpack_require__(1703),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1623:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1517)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1325),
  /* template */
  __webpack_require__(1733),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1624:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1326),
  /* template */
  __webpack_require__(1686),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1680:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.members,
      "total-items": _vm.totalItems,
      "loading": _vm.loading,
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var props = ref.props;

        return [_c('tr', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "avatar ml-2",
          staticStyle: {
            "height": "24px",
            "width": "24px"
          }
        }, [_c('img', {
          attrs: {
            "src": props.item.avatar,
            "alt": props.item.firstname + ' ' + props.item.lastname
          }
        })]), _vm._v("\n          " + _vm._s(props.item.firstname + ' ' + props.item.lastname) + "\n      ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.companylegalname))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), (_vm.user.uid === _vm.group.adminId) ? _c('td', {
          staticClass: "text-xs-left"
        }, [_c('v-tooltip', {
          attrs: {
            "right": ""
          }
        }, [_c('v-btn', {
          staticClass: "reduce-fab",
          attrs: {
            "slot": "activator",
            "flat": "",
            "fab": ""
          },
          on: {
            "click": function($event) {
              return _vm.remove(props.item)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          staticClass: "red--text"
        }, [_vm._v("mdi-close-circle")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove " + _vm._s(props.item.firstname + ' ' + props.item.lastname))])], 1)], 1) : _vm._e()])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),

/***/ 1681:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    style: ({
      'width': (_vm.width + "px")
    })
  }, [_c('v-layout', {
    staticClass: "info-bg light-blue darken-2",
    attrs: {
      "justify-center": ""
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "info-profile-img",
    attrs: {
      "justify-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "150px"
    },
    attrs: {
      "src": _vm.user.avatar
    }
  })]), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-5",
    attrs: {
      "justify-center": ""
    }
  }, [_vm._v("\n    " + _vm._s(_vm.user.firstname) + " " + _vm._s(_vm.user.lastname) + "\n  ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-3"
  }, [_c('v-divider')], 1), _vm._v(" "), _c('v-card-text', [_c('ul', {
    staticClass: "pl-0 pt-0 info-list"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      key: item.title,
      staticClass: "px-0"
    }, [(item.icon) ? _c('v-icon', {
      staticClass: "mr-1"
    }, [_vm._v(_vm._s(item.icon))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pt-1"
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), 0)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1686:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pt-0"
  }, [_c('v-card', [_c('v-card-title', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "dark": ""
    }
  }, [_vm._v("\n    TOP 5 OPPORTUNITIES\n  ")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": "",
      "dense": ""
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          return _vm.openModal(item)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      staticClass: "grey lighten-1 white--text"
    }, [_vm._v("work")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.solicitationname.toString().toUpperCase()))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.posteddate))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('opportunities-modal', {
    attrs: {
      "dialog": _vm.openDialog,
      "item": _vm.selectedItem
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1696:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "600px",
      "persistent": "",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-alert', {
    attrs: {
      "color": "success",
      "icon": "check_circle",
      "value": _vm.alert,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n      Event has been saved and submitted for Review\n    ")]), _vm._v(" "), _c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Add new Event")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Title",
      "required": "",
      "prepend-icon": "mdi-textbox"
    },
    model: {
      value: (_vm.event.title),
      callback: function($$v) {
        _vm.$set(_vm.event, "title", $$v)
      },
      expression: "event.title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenu),
      callback: function($$v) {
        _vm.datepickermenu = $$v
      },
      expression: "datepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Event Date",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.event.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.event, "eventdate", $$v)
      },
      expression: "event.eventdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.event.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.event, "eventdate", $$v)
      },
      expression: "event.eventdate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.timepickermenu),
      callback: function($$v) {
        _vm.timepickermenu = $$v
      },
      expression: "timepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Start Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.event.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "starteventtime", $$v)
      },
      expression: "event.starteventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.event.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "starteventtime", $$v)
      },
      expression: "event.starteventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.endtimepickermenu),
      callback: function($$v) {
        _vm.endtimepickermenu = $$v
      },
      expression: "endtimepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "End Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.event.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "endeventtime", $$v)
      },
      expression: "event.endeventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.event.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.event, "endeventtime", $$v)
      },
      expression: "event.endeventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Location",
      "required": "",
      "prepend-icon": "mdi-google-maps"
    },
    model: {
      value: (_vm.event.location),
      callback: function($$v) {
        _vm.$set(_vm.event, "location", $$v)
      },
      expression: "event.location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Link",
      "prepend-icon": "link"
    },
    model: {
      value: (_vm.event.link),
      callback: function($$v) {
        _vm.$set(_vm.event, "link", $$v)
      },
      expression: "event.link"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "rows": "3",
      "required": "",
      "prepend-icon": "mdi-file-document",
      "label": "Event Description"
    },
    model: {
      value: (_vm.event.description),
      callback: function($$v) {
        _vm.$set(_vm.event, "description", $$v)
      },
      expression: "event.description"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    style: ({
      color: _vm.buttonColor
    }),
    attrs: {
      "type": "submit",
      "flat": ""
    }
  }, [_vm._v("Save")])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1703:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md9": "",
      "offset-md2": "",
      "mb-2": ""
    }
  }, [_c('v-card', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "inset": ""
    }
  }, [_vm._v("Join requests")]), _vm._v(" "), _vm._l((_vm.notifications), function(item) {
    return _c('v-list-tile', {
      key: item.uid,
      attrs: {
        "avatar": ""
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.firstname + ' ' + item.lastname))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.jobtitle + ' at ' + item.companylegalname))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-layout', [_c('v-flex', {
      attrs: {
        "md6": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "green",
        "ripple": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.accept(item)
        }
      }
    }, [_vm._v("\n                        ACCEPT\n                      ")])], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "md6": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "red",
        "ripple": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.deny(item)
        }
      }
    }, [_vm._v("\n                        DENY\n                      ")])], 1)], 1)], 1)], 1)
  })], 2)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1713:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    style: ({
      backgroundColor: _vm.styles.general.background_color
    }),
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "z-index": "-1"
    }
  }, [_c('v-tabs', {
    staticStyle: {
      "top": "280px",
      "position": "absolute",
      "z-index": "1",
      "overflow-y": "hidden"
    },
    attrs: {
      "fixed": "",
      "centered": "",
      "scrollable": false,
      "grow": ""
    },
    model: {
      value: (_vm.groupPageTab),
      callback: function($$v) {
        _vm.groupPageTab = $$v
      },
      expression: "groupPageTab"
    }
  }, [_c('v-layout', {
    staticClass: "text-xs-center",
    attrs: {
      "justify-space-around": ""
    }
  }, [_c('v-flex', {
    staticClass: "pr-2 text-xs-center",
    staticStyle: {
      "overflow-y": "hidden"
    },
    attrs: {
      "sm12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-0 mr-4",
    staticStyle: {
      "overflow-y": "hidden"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "white",
    staticStyle: {
      "height": "65px",
      "overflow-y": "hidden",
      "min-height": "100%"
    },
    attrs: {
      "color": "white",
      "dark": "",
      "fixed": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": _vm.styles.general.theme_color_dark
    }
  }), _vm._v(" "), _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("home")]), _vm._v(" "), _c('span', {
    staticClass: "secondary--text"
  }, [_vm._v("Home")])], 1)]), _vm._v(" "), _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-2"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("date_range")]), _vm._v("\n                    Events\n                  ")], 1)]), _vm._v(" "), _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-3"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("group")]), _vm._v("\n                    Members\n                  ")], 1)]), _vm._v(" "), (_vm.user && _vm.group && _vm.user.uid === _vm.group.adminId) ? _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-4"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("notifications")]), _vm._v("\n                    Notifications \n                  ")], 1)]) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.uid === _vm.group.adminId) ? _c('v-tabs-item', {
    staticClass: "secondary--text",
    attrs: {
      "href": "#tab-5"
    }
  }, [_c('div', {
    staticClass: "tabItem"
  }, [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("settings")]), _vm._v("\n                    Settings\n                  ")], 1)]) : _vm._e()], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "39px",
      "width": "103%",
      "height": "250px",
      "z-index": "3",
      "margin-left": "-29px",
      "margin-right": "40px",
      "overflow-x": "hidden"
    },
    style: ({
      'backgroundImage': ("url(" + (_vm.tempImgUrl || _vm.coverPhoto) + ")"),
      'backgroundSize': 'cover',
    }),
    attrs: {
      "id": "group-cover-photo"
    }
  }, [_c('input', {
    ref: "imgupload",
    staticClass: "hidden",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.setTemp
    }
  }), _vm._v(" "), (!_vm.modify.changePhoto.hide && _vm.user.uid === _vm.group.adminId) ? _c('div', {
    staticClass: "change-photo"
  }, [(!_vm.modify.changePhoto.save) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleModify('changePhoto')
      }
    }
  }, [_vm._v("Change Cover photo")]) : _vm._e(), _vm._v(" "), (_vm.modify.changePhoto.save) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveCoverPhoto.apply(null, arguments)
      }
    }
  }, [_vm._v("Save Cover Photo")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }), _vm._v(" "), (!_vm.modify.groupTitle) ? _c('div', {
    staticClass: "group-title"
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "align-center": "",
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h4', {
    staticClass: "white--text text-outline",
    staticStyle: {
      "font-weight": "900"
    }
  }, [_vm._v(_vm._s(this.group && this.group.name ? this.group.name : 'Loading...'))]), _vm._v(" "), _c('p', {
    staticClass: "white--text text-outline",
    staticStyle: {
      "font-weight": "500",
      "margin-top": "-10px",
      "margin-left": "-10px",
      "font-size": "18px"
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white",
      "medium": ""
    }
  }, [_vm._v("group")]), _vm._v("\n              " + _vm._s(Object.keys(this.group.members).length) + " Members\n            ")], 1)])], 1), _vm._v(" "), _c('v-layout')], 1) : _vm._e(), _vm._v(" "), (!_vm.modify.reposition.hide && _vm.user.uid === _vm.group.adminId) ? _c('div', {
    staticClass: "position-photo"
  }, [(!_vm.modify.reposition.save) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleModify('reposition')
      }
    }
  }, [_vm._v("Reposition Cover photo")]) : _vm._e(), _vm._v(" "), (_vm.modify.reposition.save) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.savePosition.apply(null, arguments)
      }
    }
  }, [_vm._v("Save Position")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5",
    staticStyle: {
      "z-index": "1",
      "position": "relative"
    }
  }, [_c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": "",
      "scrollable": false,
      "grow": ""
    },
    model: {
      value: (_vm.groupPageTab),
      callback: function($$v) {
        _vm.groupPageTab = $$v
      },
      expression: "groupPageTab"
    }
  }, [_c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "postion": "relative",
      "z-index": "2"
    },
    attrs: {
      "xs12": "",
      "md3": "",
      "hidden-xs-only": "",
      "hidden-sm-only": ""
    }
  }, [_c('v-card', {
    staticClass: "mr-3"
  }, [_c('v-card-text', [_c('v-layout', {
    staticClass: "mb-2",
    attrs: {
      "justify-center": ""
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "src": this.group.logo || '/static/images/group-icon.png'
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_vm._v("About " + _vm._s(this.group && this.group.name ? this.group.name : 'Loading...'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(this.group && this.group.description ? this.group.description : 'Loading...'))]), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "py-5",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "600"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    })
  }, [_vm._v("Members")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    on: {
      "click": function($event) {
        _vm.groupPageTab = 'tab-3'
      }
    }
  }, [_vm._v("See All ")])])])], 1), _vm._v(" "), (this.group) ? _c('v-layout', {
    staticClass: "mt-2"
  }, [_vm._l((_vm.firstFiveMembers), function(user, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs2": ""
      }
    }, [(user) ? _c('v-avatar', [_c('img', {
      attrs: {
        "src": user.avatar
      }
    })]) : _vm._e()], 1)
  }), _vm._v(" "), _c('br')], 2) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [((_vm.group.members[_vm.user.uid] && _vm.group.members[_vm.user.uid].approvalStatus == 1 && _vm.privileges.groups && _vm.privileges.groups.post_to_group) || _vm.group.adminId === _vm.user.uid) ? _c('new-activity', {
    attrs: {
      "firstname": _vm.user.firstname,
      "type": _vm.type,
      "extraData": _vm.setGroupPostData,
      "extraUrl": _vm.extraUrl
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.feed), function(item) {
    return _c('timeline', {
      key: item.postKey,
      attrs: {
        "item": item,
        "user": item.user,
        "itemKey": item.postKey,
        "type": _vm.type,
        "extraUrl": _vm.extraUrl
      }
    })
  }), _vm._v(" "), (!_vm.feed.length) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "40px"
    }
  }, [_c('h5', {
    staticClass: "black--text"
  }, [_vm._v("No Group Activity yet")])]) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-flex', {
    staticClass: "load-data-div",
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('button', {
    staticClass: "btn btn--raised btn--round theme--dark load-more",
    attrs: {
      "color": _vm.styles.general.theme_color_light
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.counterPost()
      }
    }
  }, [_vm._v("Load More")])])], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "hidden-xs-only": ""
    }
  }, [_c('TopEvents', {
    attrs: {
      "groupId": _vm.strippedGroupId,
      "add": _vm.group.members[_vm.user.uid].approvalStatus == 1
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-2"
    }
  }, [_c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('events-tab', {
    attrs: {
      "groupId": _vm.strippedGroupId
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-3"
    }
  }, [_c('v-container', [_c('v-layout', [_c('members', {
    attrs: {
      "group": _vm.group,
      "groupId": _vm.strippedGroupId
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-4"
    }
  }, [_c('notifications', {
    attrs: {
      "groupId": _vm.strippedGroupId
    }
  })], 1)], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-5"
    }
  }, [_c('settings', {
    attrs: {
      "group": _vm.group,
      "groupId": _vm.strippedGroupId
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('side-view-chat')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1731:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-card', {
    staticClass: "mx-3 mb-3"
  }, [_c('v-card-title', {
    staticStyle: {
      "background-color": "#424242",
      "color": "#fff"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', [_vm._v("\n          Invite User\n          ")])], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.inviteUser.apply(null, arguments)
      }
    }
  }, [_c('v-card-text', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "text-field m",
    attrs: {
      "type": "text",
      "placeholder": "Insert user's email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-card-actions', {
    staticClass: "mt-0 pt-0",
    staticStyle: {
      "padding-left": "16px"
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "submit",
      "color": "primary"
    }
  }, [_vm._v("Invite")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1732:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('v-container', {
    staticClass: "pt-0"
  }, [_c('v-card', {
    attrs: {
      "dark": ""
    }
  }, [_c('v-card-title', {
    style: ({
      backgroundColor: _vm.styles.general.theme_color_light
    }),
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "mr-2",
    attrs: {
      "xs1": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "dark": ""
    }
  }, [_vm._v("date_range")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "500",
      "font-size": "20px"
    }
  }, [_vm._v("Upcoming Events")])]), _vm._v(" "), (_vm.add) ? _c('v-flex', {
    staticClass: "ml-3",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "xs1": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "activator",
      "dark": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openNewModal.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_vm._v("mdi-plus")]), _vm._v(" "), _c('span', [_vm._v("Add event")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, _vm._l((_vm.events), function(event) {
    return _c('v-list-tile', {
      key: event.eventKey,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openUpdateModal(event)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', {
      style: ({
        color: _vm.styles.general.theme_color_dark
      }),
      attrs: {
        "x-large": ""
      }
    }, [_vm._v("date_range")])], 1), _vm._v(" "), _c('v-list-tile-content', {
      staticClass: "eventitem",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openUpdateModal(event)
        }
      }
    }, [_c('v-list-tile-title', {
      staticStyle: {
        "font-size": "15px",
        "font-weight": "900",
        "text-transform": "capitalize"
      },
      style: ({
        color: _vm.styles.general.theme_color_dark
      })
    }, [_vm._v(_vm._s(event.title.toString()))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticStyle: {
        "font-size": "12px",
        "font-weight": "900"
      }
    }, [_vm._v("Event Date: " + _vm._s(event.eventdate))])], 1)], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('calendar-modal', {
    attrs: {
      "dialog": _vm.openCalendarModal
    }
  }), _vm._v(" "), _c('new-event-modal', {
    attrs: {
      "groupId": _vm.groupId,
      "trigger": _vm.openEventModal
    },
    on: {
      "closeModal": _vm.closeModal,
      "update:trigger": function($event) {
        _vm.openEventModal = $event
      }
    }
  }), _vm._v(" "), _c('update-event-modal', {
    attrs: {
      "groupId": _vm.groupId,
      "trigger": _vm.openUpdateEventModal,
      "item": _vm.selectedItem
    },
    on: {
      "closeModal": _vm.closeModal,
      "update:trigger": function($event) {
        _vm.openUpdateEventModal = $event
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1733:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md6": ""
    }
  }, [_c('h5', [_vm._v("Update Group Details")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Group Title"
    },
    model: {
      value: (_vm.group.name),
      callback: function($$v) {
        _vm.$set(_vm.group, "name", $$v)
      },
      expression: "group.name"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "label": "Select privacy",
      "required": "",
      "return-object": "",
      "items": [{
        text: 'Public Group',
        value: 1
      }, {
        text: 'Closed Group',
        value: 2
      }]
    },
    model: {
      value: (_vm.group.privacy),
      callback: function($$v) {
        _vm.$set(_vm.group, "privacy", $$v)
      },
      expression: "group.privacy"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "textarea": "",
      "label": "Group Title"
    },
    model: {
      value: (_vm.group.description),
      callback: function($$v) {
        _vm.$set(_vm.group, "description", $$v)
      },
      expression: "group.description"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "color": "green"
    },
    on: {
      "click": _vm.updateGroup
    }
  }, [_vm._v("\n                                UPDATE\n                            ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "ml-3",
    attrs: {
      "md5": ""
    }
  }, [_c('h5', [_vm._v("Delete Group")]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "290"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "red",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v("DELETE GROUP")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Are you sure you want to delete the group?")]), _vm._v(" "), _c('v-card-text', [_vm._v("This is an irreversible action.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteGroup.apply(null, arguments)
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "red darken-1",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1734:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', [_c('v-layout', {
    staticClass: "mx-5",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h4', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Events")])]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "font-size": "18px",
      "line-height": "1.2",
      "font-weight": "400"
    },
    attrs: {
      "xs12": ""
    }
  }, [_vm._v("\n          Events are great for getting things done and staying in touch with just the people you want.Share photos and videos,\n          have conversations, make plans and more.\n        ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    staticClass: "white my-4",
    staticStyle: {
      "height": "70px",
      "text-transform": "capitalize",
      "float": "right",
      "font-size": "18px"
    },
    style: ({
      color: _vm.styles.general.theme_color_dark
    }),
    attrs: {
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openModal.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("add")]), _vm._v("\n          Create an Event\n        ")], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-5 mt-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-tabs', {
    staticStyle: {
      "margin-left": "0px",
      "padding-left": "0px"
    },
    attrs: {
      "grow": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm7": "",
      "md4": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "white",
    attrs: {
      "dark": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": _vm.styles.general.theme_color_dark
    }
  }), _vm._v(" "), _c('v-tabs-item', {
    key: "tab-1",
    attrs: {
      "href": "#tab-1"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "color": "#000",
      "font-size": "16px"
    },
    style: ({
      color: _vm.styles.general.theme_color_light
    })
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("my_location")]), _vm._v("\n                      Events\n                    ")], 1)]), _vm._v(" "), _c('v-tabs-item', {
    key: "tab-2",
    attrs: {
      "href": "#tab-2"
    }
  }, [_c('div', {
    staticStyle: {
      "text-transform": "capitalize",
      "color": "#000",
      "font-size": "16px"
    },
    style: ({
      color: _vm.styles.general.theme_color_light
    })
  }, [_c('v-icon', {
    attrs: {
      "medium": ""
    }
  }, [_vm._v("assignment")]), _vm._v("\n                      Calendar\n                    ")], 1)])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, _vm._l((_vm.events), function(event) {
    return _c('event-timeline', {
      key: event.eventKey,
      attrs: {
        "event": event
      },
      on: {
        "viewEvent": _vm.viewEvent
      }
    })
  }), 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab-2"
    }
  }, [_c('full-calendar', {
    staticClass: "mx-3 my-3",
    attrs: {
      "events": _vm.events
    },
    on: {
      "eventClick": _vm.eventClick
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('new-events-modal', {
    attrs: {
      "groupRoute": _vm.groupRoute,
      "type": "groupevents",
      "groupId": _vm.groupId,
      "trigger": _vm.dialog
    },
    on: {
      "closeModal": _vm.closeModal,
      "update:trigger": function($event) {
        _vm.dialog = $event
      }
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('event-view-modal', {
    attrs: {
      "dialog": _vm.eventModal,
      "item": _vm.eventData
    },
    on: {
      "update:dialog": function($event) {
        _vm.eventModal = $event
      },
      "closeViewEvent": _vm.closeViewEvent
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1736:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "600px",
      "persistent": "",
      "fullscreen": _vm.screenWidth < 600,
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-alert', {
    attrs: {
      "color": "success",
      "icon": "check_circle",
      "transition": "scale-transition"
    },
    model: {
      value: (_vm.showAlert),
      callback: function($$v) {
        _vm.showAlert = $$v
      },
      expression: "showAlert"
    }
  }, [_vm._v("\n      Event has been updated successfully\n    ")]), _vm._v(" "), _c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Update Events")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Title",
      "required": "",
      "prepend-icon": "mdi-textbox",
      "disabled": this.item.user.uid !== this.user.uid
    },
    model: {
      value: (_vm.item.title),
      callback: function($$v) {
        _vm.$set(_vm.item, "title", $$v)
      },
      expression: "item.title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "disabled": this.item.user.uid !== _vm.event.user.uid,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenu),
      callback: function($$v) {
        _vm.datepickermenu = $$v
      },
      expression: "datepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Event Date",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.item.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.item, "eventdate", $$v)
      },
      expression: "item.eventdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.item.eventdate),
      callback: function($$v) {
        _vm.$set(_vm.item, "eventdate", $$v)
      },
      expression: "item.eventdate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "disabled": this.item.user.uid !== _vm.event.user.uid,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.timepickermenu),
      callback: function($$v) {
        _vm.timepickermenu = $$v
      },
      expression: "timepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "Start Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.item.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "starteventtime", $$v)
      },
      expression: "item.starteventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.item.starteventtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "starteventtime", $$v)
      },
      expression: "item.starteventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "disabled": this.item.user.uid !== this.user.uid,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.endtimepickermenu),
      callback: function($$v) {
        _vm.endtimepickermenu = $$v
      },
      expression: "endtimepickermenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "End Time",
      "readonly": "",
      "prepend-icon": "event"
    },
    slot: "activator",
    model: {
      value: (_vm.item.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "endeventtime", $$v)
      },
      expression: "item.endeventtime"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    attrs: {
      "scrollable": "",
      "actions": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Save")])], 1)]
      }
    }]),
    model: {
      value: (_vm.item.endeventtime),
      callback: function($$v) {
        _vm.$set(_vm.item, "endeventtime", $$v)
      },
      expression: "item.endeventtime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Location",
      "disabled": this.item.user.uid !== this.user.uid,
      "required": "",
      "prepend-icon": "mdi-google-maps"
    },
    model: {
      value: (_vm.item.location),
      callback: function($$v) {
        _vm.$set(_vm.item, "location", $$v)
      },
      expression: "item.location"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Event Link",
      "disabled": this.item.user.uid !== this.user.uid,
      "prepend-icon": "link"
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "multi-line": "",
      "rows": "3",
      "disabled": this.item.user.uid !== this.user.uid,
      "required": "",
      "prepend-icon": "mdi-file-document",
      "label": "Event Description"
    },
    model: {
      value: (_vm.item.description),
      callback: function($$v) {
        _vm.$set(_vm.item, "description", $$v)
      },
      expression: "item.description"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "flat": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "blue darken-1",
      "flat": "",
      "disabled": this.item.user.uid !== this.user.uid
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Update")])], 1)], 1)])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1504)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1316),
  /* template */
  __webpack_require__(1713),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(833)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(834),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      show: false,
      unread: 0,
      contacts: []
    };
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    privileges: function privileges() {
      return this.$store.getters.getUserPrivileges;
    }
  },
  methods: {
    openChat: function openChat() {
      window.$applozic('#mck-sidebox').mckModal('show');
      window.$applozic.fn.applozic('loadTab', '');
      window.$('html').addClass('sidebox-open');
      this.setDefaultContacts();
    },
    setDefaultContacts: function setDefaultContacts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var self, contactSnap, contacts, users, parentNode, noConversationNode, mckInner, nodes, fragment;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                _context.next = 3;
                return _this.$firebase.database().ref('default_chat_contact').once('value');

              case 3:
                contactSnap = _context.sent;
                contacts = contactSnap.val() || [];
                users = _this.$store.getters.fetchUsers;
                parentNode = document.getElementById('mck-contact-list');
                noConversationNode = document.getElementById('mck-no-conversations');
                mckInner = document.querySelector('#mck-message-cell .mck-message-inner');
                nodes = contacts.reduce(function (d, contact) {
                  var user = users.find(function (user) {
                    return user.uid === contact.uid;
                  }); // check if already exist

                  if (user) {
                    var contactExist = document.getElementById("li-user-".concat(user.uid));
                    if (contactExist) return d + '';
                    var node = self.getNode(user);
                    return d + node;
                  }

                  return d;
                }, '');
                fragment = document.createRange().createContextualFragment(nodes);

                if (!parentNode) {
                  mckInner.innerHTML = '<ul id="mck-contact-list" class="mck-contact-list mck-nav mck-nav-tabs mck-nav-stacked">';
                  parentNode = document.getElementById('mck-contact-list');
                }

                if (noConversationNode) {
                  setTimeout(function () {
                    noConversationNode.classList.remove('vis');
                    noConversationNode.classList.add('n-vis');
                  }, 800);
                }

                parentNode.prepend(fragment);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getNode: function getNode(user) {
      var avatar = user.avatar.indexOf('http') >= 0 ? user.avatar : "".concat(window.location.protocol, "//").concat(window.location.host).concat(user.avatar);
      var fullName = "".concat(user.firstname, " ").concat(user.lastname);
      return "\n      <li id=\"li-user-".concat(user.uid, "\" class=\"li-user-").concat(user.uid, " ").concat(user.uid, "\"\n        data-msg-time=\"1539049156786\"><a class=\"applozic-launcher\" href=\"#\" target=\"_self\" data-mck-conversationid=\"\"\n          data-mck-id=\"").concat(user.uid, "\" data-mck-clientgroupid=\"\" data-isgroup=\"false\">\n          <div class=\"mck-row\" title=\"").concat(fullName, "\">\n            <div class=\"mck-conversation-topic mck-truncate n-vis\"></div>\n            <div class=\"blk-lg-3\"><img src=\"").concat(avatar, "\"></div>\n            <div class=\"blk-lg-9\">\n              <div class=\"mck-row\">\n                <div class=\"blk-lg-8 mck-cont-name mck-truncate\">\n                  <div class=\"mck-ol-status n-vis\"><span class=\"mck-ol-icon\" title=\"Online\"></span>&nbsp;</div><strong>").concat(fullName, "</strong>\n                </div>\n                <div class=\"mck-text-muted move-right mck-cont-msg-date mck-truncate blk-lg-4\"></div>\n              </div>\n              <div class=\"mck-row\">\n                <div class=\"mck-cont-msg-wrapper blk-lg-6 mck-truncate msgTextExpr\">\n                  <p>Hello, how can I help you?</p>\n                </div>\n                <div class=\"mck-unread-count-box move-right mck-truncate n-vis\"><span class=\"mck-unread-count-text\">0</span></div>\n              </div>\n            </div>\n          </div>\n        </a>\n      </li>\n    ");
    }
  },
  beforeDestroy: function beforeDestroy() {
    var chatTotalUnreadCountId = Number(localStorage.getItem('chatTotalUnreadCountId'));
    window.clearInterval(chatTotalUnreadCountId);
    localStorage.removeItem('chatTotalUnreadCountId');
  },
  mounted: function mounted() {
    var _this2 = this;

    var self = this;
    var path = this.$route.path;
    this.$store.dispatch('loadUsers');
    if (!['/user/feed', '/contractors'].includes(path)) return;
    window.$applozic && window.$applozic.fn.applozic({
      appId: 'tsvcommunityxchange3b1149dc15a',
      userId: this.user.uid,
      userName: "".concat(this.user.firstname, "-").concat(this.user.lastname),
      imageLink: this.user.avatar,
      email: this.user.email,
      labels: {
        'last.seen.on': 'Last seen'
      },
      contactNumber: '',
      desktopNotification: true,
      source: '1',
      group: false,
      video: true,
      voice: true,
      notificationIconLink: 'https://www.applozic.com/favicon.ico',
      authenticationTypeId: 1,
      accessToken: '',
      locShare: false,
      // googleApiKey: "AIzaSyDKfWHzu9X7Z2hByeW4RRFJrD9SizOzZt4",
      googleApiKey: 'AIzaSyBCkHJdW4ChFLJ8cqJghc-LlhVU_FAl5G0',
      googleMapScriptLoaded: true,
      // mapStaticAPIkey: "AIzaSyCWRScTDtbt8tlXDr6hiceCsU83aS2UuZw",
      autoTypeSearchEnabled: true,
      loadOwnContacts: true,
      olStatus: true,
      onInit: function onInit(response) {
        if (response === 'success') {
          // calling function load contacts
          // const contactsJSON = self.$store.getters.fetchUsers
          //   .filter(val => val.id !== self.user.id)
          //   .map(user => {
          //     return {
          //       userId: user.id,
          //       displayName: `${user.firstname} ${user.lastname}`,
          //       imageLink:
          //         user.avatar.indexOf("http") < 0
          //           ? `${window.location.protocol}//${window.location.host}${
          //               user.avatar
          //             }`
          //           : user.avatar
          //     };
          //   });
          // self.contacts = contactsJSON;
          // $applozic.fn.applozic("loadContacts", { contacts: contactsJSON });
          // var startNew = document.getElementById('mck-msg-new')
          // startNew.addEventListener("mousemove", () => {
          //   $applozic.fn.applozic("loadContacts", { contacts: self.contacts });
          // });
          var closeButton = document.querySelector('.mck-box-close.mck-close-sidebox');
          closeButton.addEventListener('click', function () {
            window.$('html').removeClass('sidebox-open');
          });
          var chatTotalUnreadCountIntervalId = setInterval(function () {
            window.$applozic.fn.applozic('getUserDetail', {
              callback: function callback(response) {
                if (response.status === 'success') {
                  self.unread = response.data.totalUnreadCount;
                }
              }
            });
          }, 3000);
          window.localStorage.setItem('chatTotalUnreadCountId', chatTotalUnreadCountIntervalId);

          _this2.setDefaultContacts(); // watch for back icon click


          var backIconNodes = document.querySelectorAll('.mck-tab-link a.mck-conversation-tab-link');

          var _iterator = _createForOfIteratorHelper(backIconNodes),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var node = _step.value;
              node.addEventListener('click', function () {
                self.setDefaultContacts();
              });
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {// error in user login/register (you can hide chat button or refresh page)
        }
      },
      onTabClicked: function onTabClicked(response) {},
      contactDisplayName: function contactDisplayName(userId) {
        var users = self.$store.getters.fetchUsers;
        var contactUser = users.find(function (user) {
          return user.uid === userId;
        });

        if (contactUser) {
          return "".concat(contactUser.firstname, " ").concat(contactUser.lastname);
        }
      },
      contactDisplayImage: function contactDisplayImage(userId) {
        var users = self.$store.getters.fetchUsers;
        var contactUser = users.find(function (user) {
          return user.uid === userId;
        });

        if (contactUser) {
          return contactUser.avatar.indexOf('http') < 0 ? "".concat(window.location.protocol, "//").concat(window.location.host).concat(contactUser.avatar) : contactUser.avatar;
        }
      }
    });
  }
};

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sidebox-open{overflow:hidden!important}.chatbutton{width:66px;height:66px}#mck-contact-search-list{display:none!important}.mck-box input{line-height:inherit!important}.mck-box input::-webkit-input-placeholder{line-height:inherit!important}.mck-box input::-moz-placeholder{line-height:inherit!important}.mck-box input::-ms-input-placeholder{line-height:inherit!important}.mck-box input::placeholder{line-height:inherit!important}.mck-sidebox.fade.in{width:100%!important}.mck-alpha-contact-image img{width:43px!important;height:43px!important}.row.mck-vid-overlay-footer.mck-flex-footer{margin:0!important}.mck-vid-scr-controls{width:100%!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.row.mck-vid-overlay-header{padding-top:20px!important}.mck-vid-icon span{color:#fff!important}.mck-videocall-image{width:50px!important;height:50px!important;border-radius:100%!important}.footer-controls{width:auto!important;float:none!important;margin:0!important}.mck-contact-list .blk-lg-8{width:calc(100% - 55px)!important}.mck-running-on.vis{display:none!important}.mck-msg-box{min-height:0!important;font-size:15px!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;padding:16px 14px 10px!important}.applozic-vid-container{width:100%!important;padding:0!important;max-width:none!important}#mck-sidebox-launcher,.mck-sidebox-launcher{display:none!important}#mck-vid-icon{color:#fff!important;position:relative}#mck-vid-icon span{width:150px;display:block;position:absolute;left:-43px}.mck-vid-overlay-footer{margin-left:0!important}.mck-vid-scr-controls .footer-controls,.mck-vid-scr-controls .footer-controls button{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.mck-vid-scr-controls .footer-controls button{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;margin:4px!important}#mck-microfone-mute-btn{border-radius:50%;height:56px!important;width:56px!important}.unread{position:absolute!important;z-index:99999!important;color:#fff!important;font-size:12px!important;font-weight:700!important;background:red!important;top:0!important;right:0!important;height:20px!important;width:20px!important;border-radius:50%!important;-webkit-transform:rotate(0deg)!important;transform:rotate(0deg)!important;opacity:1!important;left:auto!important}", "", {"version":3,"sources":["/home/circleci/repo/src/components/chat/sideboxChat.vue"],"names":[],"mappings":"AACA,cACE,yBAA4B,CAC7B,AACD,YACE,WAAY,AACZ,WAAa,CACd,AACD,yBACE,sBAAyB,CAC1B,AACD,eACE,6BAAgC,CACjC,AACD,0CACE,6BAAgC,CACjC,AACD,iCACE,6BAAgC,CACjC,AACD,sCACE,6BAAgC,CACjC,AACD,4BACE,6BAAgC,CACjC,AACD,qBACE,oBAAuB,CACxB,AACD,6BACE,qBAAuB,AACvB,qBAAwB,CACzB,AACD,4CACE,kBAAqB,CACtB,AACD,sBACE,qBAAuB,AACvB,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,kCAAoC,AAChC,+BAAiC,AAC7B,gCAAmC,CAC5C,AACD,4BACE,0BAA6B,CAC9B,AACD,mBACE,oBAAuB,CACxB,AACD,qBACE,qBAAuB,AACvB,sBAAwB,AACxB,4BAA+B,CAChC,AACD,iBACE,qBAAuB,AACvB,qBAAuB,AACvB,kBAAqB,CACtB,AACD,4BACE,iCAAoC,CACrC,AACD,oBACE,sBAAyB,CAC1B,AACD,aACE,uBAA2B,AAC3B,yBAA2B,AAC3B,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,kCAAoC,AAChC,+BAAiC,AAC7B,iCAAmC,AAC3C,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,gCAAwC,CACzC,AACD,wBACE,qBAAuB,AACvB,oBAAwB,AACxB,wBAA2B,CAC5B,AAID,4CACE,sBAAyB,CAC1B,AACD,cACE,qBAAuB,AACvB,iBAAmB,CACpB,AACD,mBACE,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,UAAY,CACb,AACD,wBACE,uBAA4B,CAC7B,AAMD,qFAJE,8BAAgC,AAChC,8BAAgC,AAChC,sBAAyB,CAa1B,AAXD,8CAIE,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,kCAAoC,AAChC,+BAAiC,AAC7B,iCAAmC,AAC3C,oBAAuB,CACxB,AACD,wBACE,kBAAmB,AACnB,sBAAwB,AACxB,oBAAuB,CACxB,AACD,QACE,4BAA8B,AAC9B,wBAA0B,AAC1B,qBAAuB,AACvB,yBAA2B,AAC3B,0BAA4B,AAC5B,yBAA2B,AAC3B,gBAAoB,AACpB,kBAAsB,AACtB,sBAAwB,AACxB,qBAAuB,AACvB,4BAA8B,AAC9B,yCAA2C,AAC3C,iCAAmC,AACnC,oBAAsB,AACtB,mBAAsB,CACvB","file":"sideboxChat.vue","sourcesContent":["\n.sidebox-open {\n  overflow: hidden !important;\n}\n.chatbutton {\n  width: 66px;\n  height: 66px;\n}\n#mck-contact-search-list {\n  display: none !important;\n}\n.mck-box input {\n  line-height: inherit !important;\n}\n.mck-box input::-webkit-input-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::-moz-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::-ms-input-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::placeholder {\n  line-height: inherit !important;\n}\n.mck-sidebox.fade.in {\n  width: 100% !important;\n}\n.mck-alpha-contact-image img {\n  width: 43px !important;\n  height: 43px !important;\n}\n.row.mck-vid-overlay-footer.mck-flex-footer {\n  margin: 0 !important;\n}\n.mck-vid-scr-controls {\n  width: 100% !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n}\n.row.mck-vid-overlay-header {\n  padding-top: 20px !important;\n}\n.mck-vid-icon span {\n  color: #fff !important;\n}\n.mck-videocall-image {\n  width: 50px !important;\n  height: 50px !important;\n  border-radius: 100% !important;\n}\n.footer-controls {\n  width: auto !important;\n  float: none !important;\n  margin: 0 !important;\n}\n.mck-contact-list .blk-lg-8 {\n  width: calc(100% - 55px) !important;\n}\n.mck-running-on.vis {\n  display: none !important;\n}\n.mck-msg-box {\n  min-height: 0px !important;\n  font-size: 15px !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  padding: 16px 14px 10px 14px !important;\n}\n.applozic-vid-container {\n  width: 100% !important;\n  padding: 0px !important;\n  max-width: none !important;\n}\n#mck-sidebox-launcher {\n  display: none !important;\n}\n.mck-sidebox-launcher {\n  display: none !important;\n}\n#mck-vid-icon {\n  color: #fff !important;\n  position: relative;\n}\n#mck-vid-icon span {\n  width: 150px;\n  display: block;\n  position: absolute;\n  left: -43px;\n}\n.mck-vid-overlay-footer {\n  margin-left: 0px !important;\n}\n.mck-vid-scr-controls .footer-controls {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n.mck-vid-scr-controls .footer-controls button {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  margin: 4px !important;\n}\n#mck-microfone-mute-btn {\n  border-radius: 50%;\n  height: 56px !important;\n  width: 56px !important;\n}\n.unread {\n  position: absolute !important;\n  z-index: 99999 !important;\n  color: #fff !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  background: red !important;\n  top: 0px !important;\n  right: 0px !important;\n  height: 20px !important;\n  width: 20px !important;\n  border-radius: 50% !important;\n  -webkit-transform: rotate(0deg) !important;\n  transform: rotate(0deg) !important;\n  opacity: 1 !important;\n  left: auto !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(832);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("1e24f439", content, true, {});

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path === '/user/feed') ? _c('div', [(_vm.privileges.chat.private_chat) ? _c('v-btn', {
    staticClass: "chatbutton primary",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openChat.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticClass: "chaticon"
  }, [_vm._v("chat")]), _vm._v(" "), (_vm.unread) ? _c('span', {
    staticClass: "unread"
  }, [_vm._v(_vm._s(_vm.unread))]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 948:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  props: ['trigger', 'formats'],
  data: function data() {
    return {
      filePicker: true
    };
  },
  computed: {
    dialog: function dialog() {
      return this.trigger;
    }
  },
  methods: {
    confirm: function confirm() {
      var _this = this;

      if (this.$refs.pick.files.length === 0) {
        var snackbar = {
          active: true,
          text: 'Please add a file'
        };
        this.$store.dispatch('triggerSnackbar', snackbar);
        return;
      }

      var truth = this.formats.map(function (val) {
        return val === _this.$refs.pick.files[0].type.split('/')[1].toLowerCase();
      });
      var supported = false;
      truth.forEach(function (val) {
        supported = supported || val;
      });

      if (!supported) {
        var _snackbar = {
          active: true,
          text: 'Invaid file type'
        };
        this.$store.dispatch('triggerSnackbar', _snackbar);
        return;
      }

      this.$emit('confirm');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    pickFile: function pickFile() {
      this.$refs.pick.click();
    },
    broadcastInput: function broadcastInput() {
      this.$emit('input', [this.$refs.pick.files[0]]);
    }
  }
};

/***/ }),

/***/ 955:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(948),
  /* template */
  __webpack_require__(959),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 959:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "400"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('form', {
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirm()
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-card-title', {
    staticClass: "pb-0"
  }, [_c('input', {
    ref: "pick",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.broadcastInput()
      }
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.pickFile()
      }
    }
  }, [_c('v-icon', {
    staticClass: "text-xs-justify",
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("backup")])], 1), _vm._v(" "), _c('h6', {
    staticClass: "text-xs-center mt-2"
  }, [_vm._v("Click to choose a file")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("* " + _vm._s(_vm.formats.toString()))])], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-0"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit"
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/17.b4ba9acc2fc1a2d024a7.js